const st = new RegExp("([\\p{Ll}\\d])(\\p{Lu})", "gu"), ut = new RegExp("(\\p{Lu})([\\p{Lu}][\\p{Ll}])", "gu"), ct = new RegExp("(\\d)\\p{Ll}|(\\p{L})\\d", "u"), lt = /[^\p{L}\d]+/giu, Ie = "$1\0$2", Be = "";
function Je(i) {
  let e = i.trim();
  e = e.replace(st, Ie).replace(ut, Ie), e = e.replace(lt, "\0");
  let r = 0, t = e.length;
  for (; e.charAt(r) === "\0"; )
    r++;
  if (r === t)
    return [];
  for (; e.charAt(t - 1) === "\0"; )
    t--;
  return e.slice(r, t).split(/\0/g);
}
function ft(i) {
  const e = Je(i);
  for (let r = 0; r < e.length; r++) {
    const t = e[r], n = ct.exec(t);
    if (n) {
      const s = n.index + (n[1] ?? n[2]).length;
      e.splice(r, 1, t.slice(0, s), t.slice(s));
    }
  }
  return e;
}
function Xe(i, e) {
  const [r, t, n] = Me(i, e);
  return r + t.map(Te(e?.locale)).join(e?.delimiter ?? " ") + n;
}
function dt(i, e) {
  const [r, t, n] = Me(i, e), s = Te(e?.locale), u = ke(e?.locale), c = e?.mergeAmbiguousCharacters ? _e(s, u) : et(s, u);
  return r + t.map((h, v) => v === 0 ? s(h) : c(h, v)).join(e?.delimiter ?? "") + n;
}
function ht(i, e) {
  const [r, t, n] = Me(i, e), s = Te(e?.locale), u = ke(e?.locale), c = e?.mergeAmbiguousCharacters ? _e(s, u) : et(s, u);
  return r + t.map(c).join(e?.delimiter ?? "") + n;
}
function pt(i, e) {
  const [r, t, n] = Me(i, e), s = Te(e?.locale), u = ke(e?.locale);
  return r + t.map(_e(s, u)).join(e?.delimiter ?? " ") + n;
}
function Qe(i, e) {
  return Xe(i, { delimiter: "-", ...e });
}
function mt(i, e) {
  return Xe(i, { delimiter: "_", ...e });
}
function Te(i) {
  return i === !1 ? (e) => e.toLowerCase() : (e) => e.toLocaleLowerCase(i);
}
function ke(i) {
  return i === !1 ? (e) => e.toUpperCase() : (e) => e.toLocaleUpperCase(i);
}
function _e(i, e) {
  return (r) => `${e(r[0])}${i(r.slice(1))}`;
}
function et(i, e) {
  return (r, t) => {
    const n = r[0];
    return (t > 0 && n >= "0" && n <= "9" ? "_" + n : e(n)) + i(r.slice(1));
  };
}
function Me(i, e = {}) {
  const r = e.split ?? (e.separateNumbers ? ft : Je), t = e.prefixCharacters ?? Be, n = e.suffixCharacters ?? Be;
  let s = 0, u = i.length;
  for (; s < i.length; ) {
    const c = i.charAt(s);
    if (!t.includes(c))
      break;
    s++;
  }
  for (; u > s; ) {
    const c = u - 1, h = i.charAt(c);
    if (!n.includes(h))
      break;
    u = c;
  }
  return [
    i.slice(0, s),
    r(i.slice(s, u)),
    i.slice(u)
  ];
}
var se = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function j(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var ce = { exports: {} }, yt = ce.exports, xe;
function gt() {
  return xe || (xe = 1, (function(i, e) {
    (function(r, t, n) {
      i.exports = n(), i.exports.default = n();
    })("slugify", yt, function() {
      var r = JSON.parse(`{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E'","Ը":"Y'","Թ":"T'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C'","Կ":"K","Հ":"H","Ձ":"D'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P'","Ք":"Q'","Օ":"O''","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"'","’":"'","“":"\\"","”":"\\"","„":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}`), t = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}');
      function n(s, u) {
        if (typeof s != "string")
          throw new Error("slugify: string argument expected");
        u = typeof u == "string" ? { replacement: u } : u || {};
        var c = t[u.locale] || {}, h = u.replacement === void 0 ? "-" : u.replacement, v = u.trim === void 0 ? !0 : u.trim, C = s.normalize().split("").reduce(function(y, m) {
          var A = c[m];
          return A === void 0 && (A = r[m]), A === void 0 && (A = m), A === h && (A = " "), y + A.replace(u.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        return u.strict && (C = C.replace(/[^A-Za-z0-9\s]/g, "")), v && (C = C.trim()), C = C.replace(/\s+/g, h), u.lower && (C = C.toLowerCase()), C;
      }
      return n.extend = function(s) {
        Object.assign(r, s);
      }, n;
    });
  })(ce)), ce.exports;
}
var wt = gt();
const vt = /* @__PURE__ */ j(wt);
function St(i) {
  return vt(Qe(i), {
    lower: !0,
    strict: !0
  });
}
var S = /* @__PURE__ */ ((i) => (i.Camel = "camelCase", i.Capital = "capitalCase", i.Param = "paramCase", i.Pascal = "pascalCase", i.Slug = "slugCase", i.Snake = "snakeCase", i))(S || {});
const Rt = {
  camelCase: dt,
  capitalCase: pt,
  paramCase: Qe,
  pascalCase: ht,
  slugCase: St,
  snakeCase: mt
};
function Ct(i, e) {
  return i.some(
    (r) => typeof r == "string" ? r === e : r.test(e)
  );
}
function At(i) {
  return i === Object(i) && !Array.isArray(i) && typeof i != "function";
}
function w(i, e, r = { deep: !0 }) {
  return At(i) ? Object.keys(i).reduce((t, n) => {
    const s = r?.exclude && Ct(r.exclude, n) ? n : Rt[e](n);
    return t[s] = r.deep ? w(i[n], e, r) : i[n], t;
  }, {}) : Array.isArray(i) ? i.map((t) => w(t, e, r)) : i;
}
var Oe = /* @__PURE__ */ ((i) => (i.V1 = "v1", i))(Oe || {}), ee = /* @__PURE__ */ ((i) => (i.Production = "LIVE", i.Sandbox = "SANDBOX", i.Staging = "STAGING", i.CiCd = "CI-CD", i.Local = "LOCAL", i))(ee || {});
const Tt = {
  LIVE: "https://booking-api.revolugo.com",
  SANDBOX: "https://booking-api.sandbox.revolugo.com",
  STAGING: "https://booking-api.staging.revolugo.com",
  "CI-CD": "https://booking-api.staging.revolugo.com",
  LOCAL: "http://127.0.0.1:3001"
};
var De = /* @__PURE__ */ ((i) => (i.HOTEL_ROOM_OFFERS = "HOTEL_ROOM_OFFERS", i.HOTEL_SEARCH_POLLING = "HOTEL_SEARCH_POLLING", i))(De || {}), le = { exports: {} }, Mt = le.exports, Le;
function tt() {
  return Le || (Le = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(Mt, (function() {
      var r = 1e3, t = 6e4, n = 36e5, s = "millisecond", u = "second", c = "minute", h = "hour", v = "day", C = "week", y = "month", m = "quarter", A = "year", T = "date", d = "Invalid Date", M = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, I = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, b = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(R) {
        var o = ["th", "st", "nd", "rd"], a = R % 100;
        return "[" + R + (o[(a - 20) % 10] || o[a] || o[0]) + "]";
      } }, _ = function(R, o, a) {
        var f = String(R);
        return !f || f.length >= o ? R : "" + Array(o + 1 - f.length).join(a) + R;
      }, P = { s: _, z: function(R) {
        var o = -R.utcOffset(), a = Math.abs(o), f = Math.floor(a / 60), l = a % 60;
        return (o <= 0 ? "+" : "-") + _(f, 2, "0") + ":" + _(l, 2, "0");
      }, m: function R(o, a) {
        if (o.date() < a.date()) return -R(a, o);
        var f = 12 * (a.year() - o.year()) + (a.month() - o.month()), l = o.clone().add(f, y), g = a - l < 0, p = o.clone().add(f + (g ? -1 : 1), y);
        return +(-(f + (a - l) / (g ? l - p : p - l)) || 0);
      }, a: function(R) {
        return R < 0 ? Math.ceil(R) || 0 : Math.floor(R);
      }, p: function(R) {
        return { M: y, y: A, w: C, d: v, D: T, h, m: c, s: u, ms: s, Q: m }[R] || String(R || "").toLowerCase().replace(/s$/, "");
      }, u: function(R) {
        return R === void 0;
      } }, E = "en", B = {};
      B[E] = b;
      var F = "$isDayjsObject", K = function(R) {
        return R instanceof V || !(!R || !R[F]);
      }, N = function R(o, a, f) {
        var l;
        if (!o) return E;
        if (typeof o == "string") {
          var g = o.toLowerCase();
          B[g] && (l = g), a && (B[g] = a, l = g);
          var p = o.split("-");
          if (!l && p.length > 1) return R(p[0]);
        } else {
          var D = o.name;
          B[D] = o, l = D;
        }
        return !f && l && (E = l), l || !f && E;
      }, x = function(R, o) {
        if (K(R)) return R.clone();
        var a = typeof o == "object" ? o : {};
        return a.date = R, a.args = arguments, new V(a);
      }, O = P;
      O.l = N, O.i = K, O.w = function(R, o) {
        return x(R, { locale: o.$L, utc: o.$u, x: o.$x, $offset: o.$offset });
      };
      var V = (function() {
        function R(a) {
          this.$L = N(a.locale, null, !0), this.parse(a), this.$x = this.$x || a.x || {}, this[F] = !0;
        }
        var o = R.prototype;
        return o.parse = function(a) {
          this.$d = (function(f) {
            var l = f.date, g = f.utc;
            if (l === null) return /* @__PURE__ */ new Date(NaN);
            if (O.u(l)) return /* @__PURE__ */ new Date();
            if (l instanceof Date) return new Date(l);
            if (typeof l == "string" && !/Z$/i.test(l)) {
              var p = l.match(M);
              if (p) {
                var D = p[2] - 1 || 0, L = (p[7] || "0").substring(0, 3);
                return g ? new Date(Date.UTC(p[1], D, p[3] || 1, p[4] || 0, p[5] || 0, p[6] || 0, L)) : new Date(p[1], D, p[3] || 1, p[4] || 0, p[5] || 0, p[6] || 0, L);
              }
            }
            return new Date(l);
          })(a), this.init();
        }, o.init = function() {
          var a = this.$d;
          this.$y = a.getFullYear(), this.$M = a.getMonth(), this.$D = a.getDate(), this.$W = a.getDay(), this.$H = a.getHours(), this.$m = a.getMinutes(), this.$s = a.getSeconds(), this.$ms = a.getMilliseconds();
        }, o.$utils = function() {
          return O;
        }, o.isValid = function() {
          return this.$d.toString() !== d;
        }, o.isSame = function(a, f) {
          var l = x(a);
          return this.startOf(f) <= l && l <= this.endOf(f);
        }, o.isAfter = function(a, f) {
          return x(a) < this.startOf(f);
        }, o.isBefore = function(a, f) {
          return this.endOf(f) < x(a);
        }, o.$g = function(a, f, l) {
          return O.u(a) ? this[f] : this.set(l, a);
        }, o.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, o.valueOf = function() {
          return this.$d.getTime();
        }, o.startOf = function(a, f) {
          var l = this, g = !!O.u(f) || f, p = O.p(a), D = function(Q, q) {
            var Z = O.w(l.$u ? Date.UTC(l.$y, q, Q) : new Date(l.$y, q, Q), l);
            return g ? Z : Z.endOf(v);
          }, L = function(Q, q) {
            return O.w(l.toDate()[Q].apply(l.toDate("s"), (g ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(q)), l);
          }, G = this.$W, k = this.$M, H = this.$D, te = "set" + (this.$u ? "UTC" : "");
          switch (p) {
            case A:
              return g ? D(1, 0) : D(31, 11);
            case y:
              return g ? D(1, k) : D(0, k + 1);
            case C:
              var X = this.$locale().weekStart || 0, ne = (G < X ? G + 7 : G) - X;
              return D(g ? H - ne : H + (6 - ne), k);
            case v:
            case T:
              return L(te + "Hours", 0);
            case h:
              return L(te + "Minutes", 1);
            case c:
              return L(te + "Seconds", 2);
            case u:
              return L(te + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, o.endOf = function(a) {
          return this.startOf(a, !1);
        }, o.$set = function(a, f) {
          var l, g = O.p(a), p = "set" + (this.$u ? "UTC" : ""), D = (l = {}, l[v] = p + "Date", l[T] = p + "Date", l[y] = p + "Month", l[A] = p + "FullYear", l[h] = p + "Hours", l[c] = p + "Minutes", l[u] = p + "Seconds", l[s] = p + "Milliseconds", l)[g], L = g === v ? this.$D + (f - this.$W) : f;
          if (g === y || g === A) {
            var G = this.clone().set(T, 1);
            G.$d[D](L), G.init(), this.$d = G.set(T, Math.min(this.$D, G.daysInMonth())).$d;
          } else D && this.$d[D](L);
          return this.init(), this;
        }, o.set = function(a, f) {
          return this.clone().$set(a, f);
        }, o.get = function(a) {
          return this[O.p(a)]();
        }, o.add = function(a, f) {
          var l, g = this;
          a = Number(a);
          var p = O.p(f), D = function(k) {
            var H = x(g);
            return O.w(H.date(H.date() + Math.round(k * a)), g);
          };
          if (p === y) return this.set(y, this.$M + a);
          if (p === A) return this.set(A, this.$y + a);
          if (p === v) return D(1);
          if (p === C) return D(7);
          var L = (l = {}, l[c] = t, l[h] = n, l[u] = r, l)[p] || 1, G = this.$d.getTime() + a * L;
          return O.w(G, this);
        }, o.subtract = function(a, f) {
          return this.add(-1 * a, f);
        }, o.format = function(a) {
          var f = this, l = this.$locale();
          if (!this.isValid()) return l.invalidDate || d;
          var g = a || "YYYY-MM-DDTHH:mm:ssZ", p = O.z(this), D = this.$H, L = this.$m, G = this.$M, k = l.weekdays, H = l.months, te = l.meridiem, X = function(q, Z, ie, ae) {
            return q && (q[Z] || q(f, g)) || ie[Z].slice(0, ae);
          }, ne = function(q) {
            return O.s(D % 12 || 12, q, "0");
          }, Q = te || function(q, Z, ie) {
            var ae = q < 12 ? "AM" : "PM";
            return ie ? ae.toLowerCase() : ae;
          };
          return g.replace(I, (function(q, Z) {
            return Z || (function(ie) {
              switch (ie) {
                case "YY":
                  return String(f.$y).slice(-2);
                case "YYYY":
                  return O.s(f.$y, 4, "0");
                case "M":
                  return G + 1;
                case "MM":
                  return O.s(G + 1, 2, "0");
                case "MMM":
                  return X(l.monthsShort, G, H, 3);
                case "MMMM":
                  return X(H, G);
                case "D":
                  return f.$D;
                case "DD":
                  return O.s(f.$D, 2, "0");
                case "d":
                  return String(f.$W);
                case "dd":
                  return X(l.weekdaysMin, f.$W, k, 2);
                case "ddd":
                  return X(l.weekdaysShort, f.$W, k, 3);
                case "dddd":
                  return k[f.$W];
                case "H":
                  return String(D);
                case "HH":
                  return O.s(D, 2, "0");
                case "h":
                  return ne(1);
                case "hh":
                  return ne(2);
                case "a":
                  return Q(D, L, !0);
                case "A":
                  return Q(D, L, !1);
                case "m":
                  return String(L);
                case "mm":
                  return O.s(L, 2, "0");
                case "s":
                  return String(f.$s);
                case "ss":
                  return O.s(f.$s, 2, "0");
                case "SSS":
                  return O.s(f.$ms, 3, "0");
                case "Z":
                  return p;
              }
              return null;
            })(q) || p.replace(":", "");
          }));
        }, o.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, o.diff = function(a, f, l) {
          var g, p = this, D = O.p(f), L = x(a), G = (L.utcOffset() - this.utcOffset()) * t, k = this - L, H = function() {
            return O.m(p, L);
          };
          switch (D) {
            case A:
              g = H() / 12;
              break;
            case y:
              g = H();
              break;
            case m:
              g = H() / 3;
              break;
            case C:
              g = (k - G) / 6048e5;
              break;
            case v:
              g = (k - G) / 864e5;
              break;
            case h:
              g = k / n;
              break;
            case c:
              g = k / t;
              break;
            case u:
              g = k / r;
              break;
            default:
              g = k;
          }
          return l ? g : O.a(g);
        }, o.daysInMonth = function() {
          return this.endOf(y).$D;
        }, o.$locale = function() {
          return B[this.$L];
        }, o.locale = function(a, f) {
          if (!a) return this.$L;
          var l = this.clone(), g = N(a, f, !0);
          return g && (l.$L = g), l;
        }, o.clone = function() {
          return O.w(this.$d, this);
        }, o.toDate = function() {
          return new Date(this.valueOf());
        }, o.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, o.toISOString = function() {
          return this.$d.toISOString();
        }, o.toString = function() {
          return this.$d.toUTCString();
        }, R;
      })(), oe = V.prototype;
      return x.prototype = oe, [["$ms", s], ["$s", u], ["$m", c], ["$H", h], ["$W", v], ["$M", y], ["$y", A], ["$D", T]].forEach((function(R) {
        oe[R[1]] = function(o) {
          return this.$g(o, R[0], R[1]);
        };
      })), x.extend = function(R, o) {
        return R.$i || (R(o, V, x), R.$i = !0), x;
      }, x.locale = N, x.isDayjs = K, x.unix = function(R) {
        return x(1e3 * R);
      }, x.en = B[E], x.Ls = B, x.p = {}, x;
    }));
  })(le)), le.exports;
}
var Et = tt();
const z = /* @__PURE__ */ j(Et);
var fe = { exports: {} }, Ot = fe.exports, Pe;
function kt() {
  return Pe || (Pe = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(Ot, (function() {
      return function(r, t) {
        var n = t.prototype, s = n.format;
        n.format = function(u) {
          var c = this, h = this.$locale();
          if (!this.isValid()) return s.bind(this)(u);
          var v = this.$utils(), C = (u || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, (function(y) {
            switch (y) {
              case "Q":
                return Math.ceil((c.$M + 1) / 3);
              case "Do":
                return h.ordinal(c.$D);
              case "gggg":
                return c.weekYear();
              case "GGGG":
                return c.isoWeekYear();
              case "wo":
                return h.ordinal(c.week(), "W");
              case "w":
              case "ww":
                return v.s(c.week(), y === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return v.s(c.isoWeek(), y === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return v.s(String(c.$H === 0 ? 24 : c.$H), y === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(c.$d.getTime() / 1e3);
              case "x":
                return c.$d.getTime();
              case "z":
                return "[" + c.offsetName() + "]";
              case "zzz":
                return "[" + c.offsetName("long") + "]";
              default:
                return y;
            }
          }));
          return s.bind(this)(C);
        };
      };
    }));
  })(fe)), fe.exports;
}
var _t = kt();
const Dt = /* @__PURE__ */ j(_t);
var de = { exports: {} }, bt = de.exports, $e;
function It() {
  return $e || ($e = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(bt, (function() {
      return function(r, t, n) {
        t.prototype.isBetween = function(s, u, c, h) {
          var v = n(s), C = n(u), y = (h = h || "()")[0] === "(", m = h[1] === ")";
          return (y ? this.isAfter(v, c) : !this.isBefore(v, c)) && (m ? this.isBefore(C, c) : !this.isAfter(C, c)) || (y ? this.isBefore(v, c) : !this.isAfter(v, c)) && (m ? this.isAfter(C, c) : !this.isBefore(C, c));
        };
      };
    }));
  })(de)), de.exports;
}
var Bt = It();
const xt = /* @__PURE__ */ j(Bt);
var he = { exports: {} }, Lt = he.exports, Ue;
function Pt() {
  return Ue || (Ue = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(Lt, (function() {
      return function(r, t) {
        t.prototype.isSameOrAfter = function(n, s) {
          return this.isSame(n, s) || this.isAfter(n, s);
        };
      };
    }));
  })(he)), he.exports;
}
var $t = Pt();
const Ut = /* @__PURE__ */ j($t);
var pe = { exports: {} }, Nt = pe.exports, Ne;
function Gt() {
  return Ne || (Ne = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(Nt, (function() {
      return function(r, t) {
        t.prototype.isSameOrBefore = function(n, s) {
          return this.isSame(n, s) || this.isBefore(n, s);
        };
      };
    }));
  })(pe)), pe.exports;
}
var Ht = Gt();
const Ft = /* @__PURE__ */ j(Ht);
var me = { exports: {} }, Kt = me.exports, Ge;
function Yt() {
  return Ge || (Ge = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(Kt, (function() {
      return function(r, t, n) {
        var s = t.prototype, u = function(y) {
          return y && (y.indexOf ? y : y.s);
        }, c = function(y, m, A, T, d) {
          var M = y.name ? y : y.$locale(), I = u(M[m]), b = u(M[A]), _ = I || b.map((function(E) {
            return E.slice(0, T);
          }));
          if (!d) return _;
          var P = M.weekStart;
          return _.map((function(E, B) {
            return _[(B + (P || 0)) % 7];
          }));
        }, h = function() {
          return n.Ls[n.locale()];
        }, v = function(y, m) {
          return y.formats[m] || (function(A) {
            return A.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(T, d, M) {
              return d || M.slice(1);
            }));
          })(y.formats[m.toUpperCase()]);
        }, C = function() {
          var y = this;
          return { months: function(m) {
            return m ? m.format("MMMM") : c(y, "months");
          }, monthsShort: function(m) {
            return m ? m.format("MMM") : c(y, "monthsShort", "months", 3);
          }, firstDayOfWeek: function() {
            return y.$locale().weekStart || 0;
          }, weekdays: function(m) {
            return m ? m.format("dddd") : c(y, "weekdays");
          }, weekdaysMin: function(m) {
            return m ? m.format("dd") : c(y, "weekdaysMin", "weekdays", 2);
          }, weekdaysShort: function(m) {
            return m ? m.format("ddd") : c(y, "weekdaysShort", "weekdays", 3);
          }, longDateFormat: function(m) {
            return v(y.$locale(), m);
          }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
        };
        s.localeData = function() {
          return C.bind(this)();
        }, n.localeData = function() {
          var y = h();
          return { firstDayOfWeek: function() {
            return y.weekStart || 0;
          }, weekdays: function() {
            return n.weekdays();
          }, weekdaysShort: function() {
            return n.weekdaysShort();
          }, weekdaysMin: function() {
            return n.weekdaysMin();
          }, months: function() {
            return n.months();
          }, monthsShort: function() {
            return n.monthsShort();
          }, longDateFormat: function(m) {
            return v(y, m);
          }, meridiem: y.meridiem, ordinal: y.ordinal };
        }, n.months = function() {
          return c(h(), "months");
        }, n.monthsShort = function() {
          return c(h(), "monthsShort", "months", 3);
        }, n.weekdays = function(y) {
          return c(h(), "weekdays", null, null, y);
        }, n.weekdaysShort = function(y) {
          return c(h(), "weekdaysShort", "weekdays", 3, y);
        }, n.weekdaysMin = function(y) {
          return c(h(), "weekdaysMin", "weekdays", 2, y);
        };
      };
    }));
  })(me)), me.exports;
}
var Vt = Yt();
const qt = /* @__PURE__ */ j(Vt);
var ye = { exports: {} }, jt = ye.exports, He;
function zt() {
  return He || (He = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(jt, (function() {
      var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
      return function(t, n, s) {
        var u = n.prototype, c = u.format;
        s.en.formats = r, u.format = function(h) {
          h === void 0 && (h = "YYYY-MM-DDTHH:mm:ssZ");
          var v = this.$locale().formats, C = (function(y, m) {
            return y.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(A, T, d) {
              var M = d && d.toUpperCase();
              return T || m[d] || r[d] || m[M].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(I, b, _) {
                return b || _.slice(1);
              }));
            }));
          })(h, v === void 0 ? {} : v);
          return c.call(this, C);
        };
      };
    }));
  })(ye)), ye.exports;
}
var Wt = zt();
const Zt = /* @__PURE__ */ j(Wt);
var ge = { exports: {} }, Jt = ge.exports, Fe;
function Xt() {
  return Fe || (Fe = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(Jt, (function() {
      return function(r, t, n) {
        var s = function(u, c) {
          if (!c || !c.length || c.length === 1 && !c[0] || c.length === 1 && Array.isArray(c[0]) && !c[0].length) return null;
          var h;
          c.length === 1 && c[0].length > 0 && (c = c[0]), h = (c = c.filter((function(C) {
            return C;
          })))[0];
          for (var v = 1; v < c.length; v += 1) c[v].isValid() && !c[v][u](h) || (h = c[v]);
          return h;
        };
        n.max = function() {
          var u = [].slice.call(arguments, 0);
          return s("isAfter", u);
        }, n.min = function() {
          var u = [].slice.call(arguments, 0);
          return s("isBefore", u);
        };
      };
    }));
  })(ge)), ge.exports;
}
var Qt = Xt();
const er = /* @__PURE__ */ j(Qt);
var we = { exports: {} }, tr = we.exports, Ke;
function rr() {
  return Ke || (Ke = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(tr, (function() {
      return function(r, t, n) {
        r = r || {};
        var s = t.prototype, u = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
        function c(v, C, y, m) {
          return s.fromToBase(v, C, y, m);
        }
        n.en.relativeTime = u, s.fromToBase = function(v, C, y, m, A) {
          for (var T, d, M, I = y.$locale().relativeTime || u, b = r.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], _ = b.length, P = 0; P < _; P += 1) {
            var E = b[P];
            E.d && (T = m ? n(v).diff(y, E.d, !0) : y.diff(v, E.d, !0));
            var B = (r.rounding || Math.round)(Math.abs(T));
            if (M = T > 0, B <= E.r || !E.r) {
              B <= 1 && P > 0 && (E = b[P - 1]);
              var F = I[E.l];
              A && (B = A("" + B)), d = typeof F == "string" ? F.replace("%d", B) : F(B, C, E.l, M);
              break;
            }
          }
          if (C) return d;
          var K = M ? I.future : I.past;
          return typeof K == "function" ? K(d) : K.replace("%s", d);
        }, s.to = function(v, C) {
          return c(v, C, this, !0);
        }, s.from = function(v, C) {
          return c(v, C, this);
        };
        var h = function(v) {
          return v.$u ? n.utc() : n();
        };
        s.toNow = function(v) {
          return this.to(h(this), v);
        }, s.fromNow = function(v) {
          return this.from(h(this), v);
        };
      };
    }));
  })(we)), we.exports;
}
var nr = rr();
const ir = /* @__PURE__ */ j(nr);
var ve = { exports: {} }, or = ve.exports, Ye;
function ar() {
  return Ye || (Ye = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(or, (function() {
      var r = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, t = {};
      return function(n, s, u) {
        var c, h = function(m, A, T) {
          T === void 0 && (T = {});
          var d = new Date(m), M = (function(I, b) {
            b === void 0 && (b = {});
            var _ = b.timeZoneName || "short", P = I + "|" + _, E = t[P];
            return E || (E = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: I, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: _ }), t[P] = E), E;
          })(A, T);
          return M.formatToParts(d);
        }, v = function(m, A) {
          for (var T = h(m, A), d = [], M = 0; M < T.length; M += 1) {
            var I = T[M], b = I.type, _ = I.value, P = r[b];
            P >= 0 && (d[P] = parseInt(_, 10));
          }
          var E = d[3], B = E === 24 ? 0 : E, F = d[0] + "-" + d[1] + "-" + d[2] + " " + B + ":" + d[4] + ":" + d[5] + ":000", K = +m;
          return (u.utc(F).valueOf() - (K -= K % 1e3)) / 6e4;
        }, C = s.prototype;
        C.tz = function(m, A) {
          m === void 0 && (m = c);
          var T, d = this.utcOffset(), M = this.toDate(), I = M.toLocaleString("en-US", { timeZone: m }), b = Math.round((M - new Date(I)) / 1e3 / 60), _ = 15 * -Math.round(M.getTimezoneOffset() / 15) - b;
          if (!Number(_)) T = this.utcOffset(0, A);
          else if (T = u(I, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(_, !0), A) {
            var P = T.utcOffset();
            T = T.add(d - P, "minute");
          }
          return T.$x.$timezone = m, T;
        }, C.offsetName = function(m) {
          var A = this.$x.$timezone || u.tz.guess(), T = h(this.valueOf(), A, { timeZoneName: m }).find((function(d) {
            return d.type.toLowerCase() === "timezonename";
          }));
          return T && T.value;
        };
        var y = C.startOf;
        C.startOf = function(m, A) {
          if (!this.$x || !this.$x.$timezone) return y.call(this, m, A);
          var T = u(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return y.call(T, m, A).tz(this.$x.$timezone, !0);
        }, u.tz = function(m, A, T) {
          var d = T && A, M = T || A || c, I = v(+u(), M);
          if (typeof m != "string") return u(m).tz(M);
          var b = (function(B, F, K) {
            var N = B - 60 * F * 1e3, x = v(N, K);
            if (F === x) return [N, F];
            var O = v(N -= 60 * (x - F) * 1e3, K);
            return x === O ? [N, x] : [B - 60 * Math.min(x, O) * 1e3, Math.max(x, O)];
          })(u.utc(m, d).valueOf(), I, M), _ = b[0], P = b[1], E = u(_).utcOffset(P);
          return E.$x.$timezone = M, E;
        }, u.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, u.tz.setDefault = function(m) {
          c = m;
        };
      };
    }));
  })(ve)), ve.exports;
}
var sr = ar();
const ur = /* @__PURE__ */ j(sr);
var Se = { exports: {} }, cr = Se.exports, Ve;
function lr() {
  return Ve || (Ve = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(cr, (function() {
      var r = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
      return function(s, u, c) {
        var h = u.prototype;
        c.utc = function(d) {
          var M = { date: d, utc: !0, args: arguments };
          return new u(M);
        }, h.utc = function(d) {
          var M = c(this.toDate(), { locale: this.$L, utc: !0 });
          return d ? M.add(this.utcOffset(), r) : M;
        }, h.local = function() {
          return c(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var v = h.parse;
        h.parse = function(d) {
          d.utc && (this.$u = !0), this.$utils().u(d.$offset) || (this.$offset = d.$offset), v.call(this, d);
        };
        var C = h.init;
        h.init = function() {
          if (this.$u) {
            var d = this.$d;
            this.$y = d.getUTCFullYear(), this.$M = d.getUTCMonth(), this.$D = d.getUTCDate(), this.$W = d.getUTCDay(), this.$H = d.getUTCHours(), this.$m = d.getUTCMinutes(), this.$s = d.getUTCSeconds(), this.$ms = d.getUTCMilliseconds();
          } else C.call(this);
        };
        var y = h.utcOffset;
        h.utcOffset = function(d, M) {
          var I = this.$utils().u;
          if (I(d)) return this.$u ? 0 : I(this.$offset) ? y.call(this) : this.$offset;
          if (typeof d == "string" && (d = (function(E) {
            E === void 0 && (E = "");
            var B = E.match(t);
            if (!B) return null;
            var F = ("" + B[0]).match(n) || ["-", 0, 0], K = F[0], N = 60 * +F[1] + +F[2];
            return N === 0 ? 0 : K === "+" ? N : -N;
          })(d), d === null)) return this;
          var b = Math.abs(d) <= 16 ? 60 * d : d;
          if (b === 0) return this.utc(M);
          var _ = this.clone();
          if (M) return _.$offset = b, _.$u = !1, _;
          var P = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (_ = this.local().add(b + P, r)).$offset = b, _.$x.$localOffset = P, _;
        };
        var m = h.format;
        h.format = function(d) {
          var M = d || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return m.call(this, M);
        }, h.valueOf = function() {
          var d = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * d;
        }, h.isUTC = function() {
          return !!this.$u;
        }, h.toISOString = function() {
          return this.toDate().toISOString();
        }, h.toString = function() {
          return this.toDate().toUTCString();
        };
        var A = h.toDate;
        h.toDate = function(d) {
          return d === "s" && this.$offset ? c(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : A.call(this);
        };
        var T = h.diff;
        h.diff = function(d, M, I) {
          if (d && this.$u === d.$u) return T.call(this, d, M, I);
          var b = this.local(), _ = c(d).local();
          return T.call(b, _, M, I);
        };
      };
    }));
  })(Se)), Se.exports;
}
var fr = lr();
const dr = /* @__PURE__ */ j(fr);
var Re = { exports: {} }, hr = Re.exports, qe;
function pr() {
  return qe || (qe = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t(tt());
    })(hr, (function(r) {
      function t(u) {
        return u && typeof u == "object" && "default" in u ? u : { default: u };
      }
      var n = t(r), s = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(u) {
        return "" + u + (u === 1 ? "er" : "");
      } };
      return n.default.locale(s, null, !0), s;
    }));
  })(Re)), Re.exports;
}
pr();
var Ce = { exports: {} }, mr = Ce.exports, je;
function yr() {
  return je || (je = 1, (function(i, e) {
    (function(r, t) {
      i.exports = t();
    })(mr, (function() {
      return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(r) {
        var t = ["th", "st", "nd", "rd"], n = r % 100;
        return "[" + r + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
      } };
    }));
  })(Ce)), Ce.exports;
}
yr();
z.extend(Dt);
z.extend(xt);
z.extend(Ut);
z.extend(Ft);
z.extend(Zt);
z.extend(qt);
z.extend(er);
z.extend(ir);
z.extend(ur);
z.extend(dr);
function J(i) {
  if (i === null || typeof i != "object")
    return !1;
  const e = Object.getPrototypeOf(i);
  return e === Object.prototype || e === null;
}
function Ae(i, e = /* @__PURE__ */ new WeakSet()) {
  if (i == null || typeof i != "object" || e.has(i))
    return i;
  if (e.add(i), Array.isArray(i))
    return i.map((r) => Ae(r, e));
  if (J(i)) {
    const r = {};
    for (const t in i)
      Object.hasOwn(i, t) && (r[t] = Ae(i[t], e));
    return r;
  }
  return i;
}
function be(i, e, r = /* @__PURE__ */ new WeakSet()) {
  if (!(!J(e) || !J(i)) && !(e === i || r.has(e))) {
    r.add(e);
    for (const t in e)
      if (Object.hasOwn(e, t)) {
        const n = e[t], s = i[t];
        J(n) && J(s) ? be(s, n, r) : Array.isArray(n) && Array.isArray(s) ? i[t] = rt(s, n, r) : i[t] = Ae(n, r);
      }
  }
}
function rt(i, e, r) {
  const t = i.slice();
  for (let n = 0; n < e.length; n++) {
    const s = e[n], u = t[n];
    if (J(s) && J(u)) {
      const c = { ...u };
      be(c, s, r), t[n] = c;
    } else Array.isArray(s) && Array.isArray(u) ? t[n] = rt(u, s, r) : t[n] = Ae(s, r);
  }
  return t;
}
function ze(i, ...e) {
  if (!J(i))
    throw new TypeError("Target must be a plain object");
  const r = /* @__PURE__ */ new WeakSet();
  for (const t of e)
    t != null && be(i, t, r);
  return i;
}
const Y = [];
for (let i = 0; i < 256; ++i)
  Y.push((i + 256).toString(16).slice(1));
function gr(i, e = 0) {
  return (Y[i[e + 0]] + Y[i[e + 1]] + Y[i[e + 2]] + Y[i[e + 3]] + "-" + Y[i[e + 4]] + Y[i[e + 5]] + "-" + Y[i[e + 6]] + Y[i[e + 7]] + "-" + Y[i[e + 8]] + Y[i[e + 9]] + "-" + Y[i[e + 10]] + Y[i[e + 11]] + Y[i[e + 12]] + Y[i[e + 13]] + Y[i[e + 14]] + Y[i[e + 15]]).toLowerCase();
}
let Ee;
const wr = new Uint8Array(16);
function vr() {
  if (!Ee) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Ee = crypto.getRandomValues.bind(crypto);
  }
  return Ee(wr);
}
const Sr = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), We = { randomUUID: Sr };
function Rr(i, e, r) {
  i = i || {};
  const t = i.random ?? i.rng?.() ?? vr();
  if (t.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128, gr(t);
}
function Cr(i, e, r) {
  return We.randomUUID && !i ? We.randomUUID() : Rr(i);
}
const Ar = 1500;
class re {
  static instance = null;
  defaultOptions = {
    callCount: 1,
    interval: Ar,
    maxCallCount: 20,
    minCallCount: 1
  };
  pollings = {};
  events = {
    complete: () => {
    },
    data: () => {
    },
    error: () => {
    }
  };
  static getInstance() {
    return re.instance || (re.instance = new re()), re.instance;
  }
  poll(e, r) {
    const t = this.buildPollerOptions(r);
    return this.storeCurrentPolling(t), this.isActivePoller(t) && e().then((n) => this.onRequest(n, e, t)).catch((n) => {
      this.dispatch("error", n);
    }), this;
  }
  on(e, r) {
    this.events[e] = r;
  }
  stop(e) {
    e && this.pollings[e] && delete this.pollings[e];
  }
  dispatch(e, r) {
    this.events[e](r);
  }
  async onRequest(e, r, t) {
    const n = w(e ?? {}, S.Camel);
    this.isActivePoller(t) && (this.isInProgress(n) && t.callCount && t.maxCallCount && t.callCount < t.maxCallCount || !this.isInProgress(n) && t.callCount && t.minCallCount && t.callCount < t.minCallCount ? (this.isInProgress(n) || (n.meta = n.meta || {}, n.meta.status = "IN_PROGRESS"), t.callCount += 1, this.dispatch("data", n), t.interval && await this.pause(t), this.poll(r, t)) : this.isInProgress(n) ? (n.meta = n.meta || {}, n.meta.status = "COMPLETE", this.onComplete(n, t)) : this.onComplete(n, t));
  }
  onComplete(e, r) {
    this.dispatch("data", e), this.dispatch("complete", e), this.removeCurrentPolling(r);
  }
  isInProgress(e) {
    return (e?.meta?.status ?? "") !== "COMPLETE";
  }
  buildPollerOptions(e) {
    const r = Object.entries(e).reduce((t, [n, s]) => {
      if (s !== void 0) {
        const u = n;
        t[u] = s;
      }
      return t;
    }, {});
    return {
      ...this.defaultOptions,
      ...r
    };
  }
  storeCurrentPolling(e) {
    e.type && !e.uuid && (e.uuid = Cr(), this.pollings[e.type] = e.uuid);
  }
  isActivePoller(e) {
    return e.type ? !!this.pollings[e.type] && this.pollings[e.type] === e.uuid : !0;
  }
  pause(e) {
    return new Promise((r) => {
      setTimeout(r, e.interval);
    });
  }
  removeCurrentPolling(e) {
    e.type && this.pollings[e.type] && delete this.pollings[e.type];
  }
}
function nt(i, e, r) {
  const t = re.getInstance();
  return t.poll(i, e), r && typeof r == "function" ? (t.on("data", (n) => {
    n instanceof Error ? r(n, void 0, t) : r(null, n, t);
  }), t.on("error", (n) => {
    n instanceof Error ? r(n) : r(null, n);
  }), t) : new Promise((n, s) => {
    t.on("error", s), t.on("complete", (u) => {
      u instanceof Error ? s(u) : n(u);
    });
  });
}
const Tr = "http://localhost".replace(/\/+$/, ""), Mr = (i) => typeof Blob < "u" && i instanceof Blob;
class W {
  constructor(e = new it()) {
    this.configuration = e, this.middleware = e.middleware;
  }
  middleware;
  withMiddleware(...e) {
    const r = this.clone();
    return r.middleware = r.middleware.concat(...e), r;
  }
  withPreMiddleware(...e) {
    const r = e.map((t) => ({ pre: t }));
    return this.withMiddleware(...r);
  }
  withPostMiddleware(...e) {
    const r = e.map((t) => ({ post: t }));
    return this.withMiddleware(...r);
  }
  async request(e, r) {
    const { url: t, init: n } = this.createFetchParams(e, r), s = await this.fetchApi(t, n);
    if (s.status >= 200 && s.status < 300)
      return s;
    throw new Er(s, "Response returned an error code");
  }
  createFetchParams(e, r) {
    let t = this.configuration.basePath + e.path;
    e.query !== void 0 && Object.keys(e.query).length !== 0 && (t += "?" + this.configuration.queryParamsStringify(e.query));
    const n = typeof FormData < "u" && e.body instanceof FormData || e.body instanceof URLSearchParams || Mr(e.body) ? e.body : JSON.stringify(e.body), s = Object.assign({}, this.configuration.headers, e.headers);
    Object.keys(s).forEach((c) => s[c] === void 0 ? delete s[c] : {});
    const u = {
      method: e.method,
      body: n,
      credentials: this.configuration.credentials,
      ...ze({}, r, {
        headers: ze({}, s, r?.headers)
      })
    };
    return { url: t, init: u };
  }
  fetchApi = async (e, r) => {
    let t = { url: e, init: r };
    for (const s of this.middleware)
      s.pre && (t = await s.pre({
        fetch: this.fetchApi,
        ...t
      }) || t);
    let n = await (this.configuration.fetchApi || fetch)(t.url, t.init);
    for (const s of this.middleware)
      s.post && (n = await s.post({
        fetch: this.fetchApi,
        url: t.url,
        init: t.init,
        response: n.clone()
      }) || n);
    return n;
  };
  /**
   * Create a shallow clone of `this` by constructing a new instance
   * and then shallow cloning data members.
   */
  clone() {
    const e = this.constructor, r = new e(this.configuration);
    return r.middleware = this.middleware.slice(), r;
  }
}
class Er extends Error {
  constructor(e, r) {
    super(r), this.response = e;
  }
  name = "ResponseError";
}
class U extends Error {
  constructor(e, r) {
    super(r), this.field = e;
  }
  name = "RequiredError";
}
const Vr = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
class it {
  constructor(e = {}) {
    this.configuration = e;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : Tr;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || ot;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const e = this.configuration.apiKey;
    if (e)
      return typeof e == "function" ? e : () => e;
  }
  get accessToken() {
    const e = this.configuration.accessToken;
    if (e)
      return typeof e == "function" ? e : async () => e;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
}
function qr(i, e) {
  const r = i[e];
  return r != null;
}
function ot(i, e = "") {
  return Object.keys(i).map((r) => {
    const t = e + (e.length ? `[${r}]` : r), n = i[r];
    if (n instanceof Array) {
      const s = n.map((u) => encodeURIComponent(String(u))).join(`&${encodeURIComponent(t)}=`);
      return `${encodeURIComponent(t)}=${s}`;
    }
    return n instanceof Date ? `${encodeURIComponent(t)}=${encodeURIComponent(n.toISOString())}` : n instanceof Object ? ot(n, t) : `${encodeURIComponent(t)}=${encodeURIComponent(String(n))}`;
  }).filter((r) => r.length > 0).join("&");
}
function jr(i, e) {
  return Object.keys(i).reduce(
    (r, t) => ({ ...r, [t]: e(i[t]) }),
    {}
  );
}
function zr(i) {
  for (const e of i)
    if (e.contentType === "multipart/form-data")
      return !0;
  return !1;
}
class $ {
  constructor(e, r = (t) => t) {
    this.raw = e, this.transformer = r;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
}
class Wr {
  constructor(e) {
    this.raw = e;
  }
  async value() {
  }
}
class Zr {
  constructor(e) {
    this.raw = e;
  }
  async value() {
    return await this.raw.blob();
  }
}
class Or {
  constructor(e) {
    this.raw = e;
  }
  async value() {
    return await this.raw.text();
  }
}
const Jr = {
  Disabled: "DISABLED",
  Enabled: "ENABLED",
  Forced: "FORCED"
}, Xr = {
  Cx: "bkg-cx",
  Cf: "bkg-cf",
  Created: "bkg-created",
  Af: "bkg-af",
  Ip: "bkg-ip",
  Pc: "bkg-pc",
  Pp: "bkg-pp",
  Qr: "bkg-qr"
}, Qr = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
}, en = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
}, tn = {
  Dr: "dr",
  Mr: "mr",
  Mrs: "mrs",
  Ms: "ms",
  NotSpecified: "notSpecified",
  Prof: "prof"
}, rn = {
  Ad: "AD",
  Ae: "AE",
  Af: "AF",
  Ag: "AG",
  Ai: "AI",
  Al: "AL",
  Am: "AM",
  Ao: "AO",
  Ar: "AR",
  As: "AS",
  At: "AT",
  Au: "AU",
  Aw: "AW",
  Ax: "AX",
  Az: "AZ",
  Ba: "BA",
  Bb: "BB",
  Bd: "BD",
  Be: "BE",
  Bf: "BF",
  Bg: "BG",
  Bh: "BH",
  Bi: "BI",
  Bj: "BJ",
  Bl: "BL",
  Bm: "BM",
  Bn: "BN",
  Bo: "BO",
  Bq: "BQ",
  Br: "BR",
  Bs: "BS",
  Bt: "BT",
  Bw: "BW",
  By: "BY",
  Bz: "BZ",
  Ca: "CA",
  Cc: "CC",
  Cd: "CD",
  Cf: "CF",
  Cg: "CG",
  Ch: "CH",
  Ci: "CI",
  Ck: "CK",
  Cl: "CL",
  Cm: "CM",
  Cn: "CN",
  Co: "CO",
  Cr: "CR",
  Cu: "CU",
  Cv: "CV",
  Cw: "CW",
  Cx: "CX",
  Cy: "CY",
  Cz: "CZ",
  De: "DE",
  Dj: "DJ",
  Dk: "DK",
  Dm: "DM",
  Do: "DO",
  Dz: "DZ",
  Ec: "EC",
  Ee: "EE",
  Eg: "EG",
  Eh: "EH",
  Er: "ER",
  Es: "ES",
  Et: "ET",
  Fi: "FI",
  Fj: "FJ",
  Fk: "FK",
  Fm: "FM",
  Fo: "FO",
  Fr: "FR",
  Ga: "GA",
  Gb: "GB",
  Gd: "GD",
  Ge: "GE",
  Gf: "GF",
  Gg: "GG",
  Gh: "GH",
  Gi: "GI",
  Gl: "GL",
  Gm: "GM",
  Gn: "GN",
  Gp: "GP",
  Gq: "GQ",
  Gr: "GR",
  Gt: "GT",
  Gu: "GU",
  Gw: "GW",
  Gy: "GY",
  Hk: "HK",
  Hn: "HN",
  Hr: "HR",
  Ht: "HT",
  Hu: "HU",
  Id: "ID",
  Ie: "IE",
  Il: "IL",
  Im: "IM",
  In: "IN",
  Io: "IO",
  Iq: "IQ",
  Ir: "IR",
  Is: "IS",
  It: "IT",
  Je: "JE",
  Jm: "JM",
  Jo: "JO",
  Jp: "JP",
  Ke: "KE",
  Kg: "KG",
  Kh: "KH",
  Ki: "KI",
  Km: "KM",
  Kn: "KN",
  Kp: "KP",
  Kr: "KR",
  Kw: "KW",
  Ky: "KY",
  Kz: "KZ",
  La: "LA",
  Lb: "LB",
  Lc: "LC",
  Li: "LI",
  Lk: "LK",
  Lr: "LR",
  Ls: "LS",
  Lt: "LT",
  Lu: "LU",
  Lv: "LV",
  Ly: "LY",
  Ma: "MA",
  Mc: "MC",
  Md: "MD",
  Me: "ME",
  Mf: "MF",
  Mg: "MG",
  Mh: "MH",
  Mk: "MK",
  Ml: "ML",
  Mm: "MM",
  Mn: "MN",
  Mo: "MO",
  Mp: "MP",
  Mq: "MQ",
  Mr: "MR",
  Ms: "MS",
  Mt: "MT",
  Mu: "MU",
  Mv: "MV",
  Mw: "MW",
  Mx: "MX",
  My: "MY",
  Mz: "MZ",
  Na: "NA",
  Nc: "NC",
  Ne: "NE",
  Nf: "NF",
  Ng: "NG",
  Ni: "NI",
  Nl: "NL",
  No: "NO",
  Np: "NP",
  Nr: "NR",
  Nu: "NU",
  Nz: "NZ",
  Om: "OM",
  Pa: "PA",
  Pe: "PE",
  Pf: "PF",
  Pg: "PG",
  Ph: "PH",
  Pk: "PK",
  Pl: "PL",
  Pm: "PM",
  Pr: "PR",
  Ps: "PS",
  Pt: "PT",
  Pw: "PW",
  Py: "PY",
  Qa: "QA",
  Re: "RE",
  Ro: "RO",
  Rs: "RS",
  Ru: "RU",
  Rw: "RW",
  Sa: "SA",
  Sb: "SB",
  Sc: "SC",
  Sd: "SD",
  Se: "SE",
  Sg: "SG",
  Sh: "SH",
  Si: "SI",
  Sj: "SJ",
  Sk: "SK",
  Sl: "SL",
  Sm: "SM",
  Sn: "SN",
  So: "SO",
  Sr: "SR",
  Ss: "SS",
  St: "ST",
  Sv: "SV",
  Sx: "SX",
  Sy: "SY",
  Sz: "SZ",
  Tc: "TC",
  Td: "TD",
  Tg: "TG",
  Th: "TH",
  Tj: "TJ",
  Tk: "TK",
  Tl: "TL",
  Tm: "TM",
  Tn: "TN",
  To: "TO",
  Tr: "TR",
  Tt: "TT",
  Tv: "TV",
  Tw: "TW",
  Tz: "TZ",
  Ua: "UA",
  Ug: "UG",
  Us: "US",
  Uy: "UY",
  Uz: "UZ",
  Va: "VA",
  Vc: "VC",
  Ve: "VE",
  Vg: "VG",
  Vi: "VI",
  Vn: "VN",
  Vu: "VU",
  Wf: "WF",
  Ws: "WS",
  Xk: "XK",
  Ye: "YE",
  Yt: "YT",
  Za: "ZA",
  Zm: "ZM",
  Zw: "ZW"
}, nn = {
  Aed: "AED",
  Afn: "AFN",
  All: "ALL",
  Amd: "AMD",
  Ang: "ANG",
  Aoa: "AOA",
  Ars: "ARS",
  Aud: "AUD",
  Awg: "AWG",
  Azn: "AZN",
  Bam: "BAM",
  Bbd: "BBD",
  Bdt: "BDT",
  Bhd: "BHD",
  Bgn: "BGN",
  Bif: "BIF",
  Bmd: "BMD",
  Bnd: "BND",
  Bob: "BOB",
  Brl: "BRL",
  Bsd: "BSD",
  Bwp: "BWP",
  Bzd: "BZD",
  Cad: "CAD",
  Cdf: "CDF",
  Chf: "CHF",
  Clp: "CLP",
  Cny: "CNY",
  Cop: "COP",
  Crc: "CRC",
  Cve: "CVE",
  Czk: "CZK",
  Djf: "DJF",
  Dkk: "DKK",
  Dop: "DOP",
  Dzd: "DZD",
  Egp: "EGP",
  Etb: "ETB",
  Eur: "EUR",
  Fjd: "FJD",
  Fkp: "FKP",
  Gbp: "GBP",
  Gel: "GEL",
  Gip: "GIP",
  Gmd: "GMD",
  Gnf: "GNF",
  Gtq: "GTQ",
  Gyd: "GYD",
  Hkd: "HKD",
  Hnl: "HNL",
  Htg: "HTG",
  Huf: "HUF",
  Idr: "IDR",
  Ils: "ILS",
  Inr: "INR",
  Isk: "ISK",
  Jmd: "JMD",
  Jod: "JOD",
  Jpy: "JPY",
  Kes: "KES",
  Kgs: "KGS",
  Khr: "KHR",
  Kmf: "KMF",
  Krw: "KRW",
  Kwd: "KWD",
  Kyd: "KYD",
  Kzt: "KZT",
  Lak: "LAK",
  Lbp: "LBP",
  Lkr: "LKR",
  Lrd: "LRD",
  Lsl: "LSL",
  Mad: "MAD",
  Mdl: "MDL",
  Mga: "MGA",
  Mkd: "MKD",
  Mmk: "MMK",
  Mnt: "MNT",
  Mop: "MOP",
  Mru: "MRU",
  Mur: "MUR",
  Mvr: "MVR",
  Mwk: "MWK",
  Mxn: "MXN",
  Myr: "MYR",
  Mzn: "MZN",
  Nad: "NAD",
  Ngn: "NGN",
  Nio: "NIO",
  Nok: "NOK",
  Npr: "NPR",
  Nzd: "NZD",
  Omr: "OMR",
  Pab: "PAB",
  Pen: "PEN",
  Pgk: "PGK",
  Php: "PHP",
  Pkr: "PKR",
  Pln: "PLN",
  Pyg: "PYG",
  Qar: "QAR",
  Ron: "RON",
  Rsd: "RSD",
  Rub: "RUB",
  Rwf: "RWF",
  Sar: "SAR",
  Sbd: "SBD",
  Scr: "SCR",
  Sek: "SEK",
  Sgd: "SGD",
  Shp: "SHP",
  Sll: "SLL",
  Sos: "SOS",
  Srd: "SRD",
  Std: "STD",
  Szl: "SZL",
  Thb: "THB",
  Tjs: "TJS",
  Tnd: "TND",
  Top: "TOP",
  Try: "TRY",
  Ttd: "TTD",
  Twd: "TWD",
  Tzs: "TZS",
  Uah: "UAH",
  Usd: "USD",
  Uyu: "UYU",
  Uzs: "UZS",
  Vnd: "VND",
  Vuv: "VUV",
  Wst: "WST",
  Xaf: "XAF",
  Xcd: "XCD",
  Xof: "XOF",
  Xpf: "XPF",
  Yer: "YER",
  Zar: "ZAR",
  Zmw: "ZMW"
}, on = {
  ApiError: "api_error",
  BadGateway: "bad_gateway",
  InternalServerError: "internal_server_error",
  InvalidRequestError: "invalid_request_error",
  RateLimitError: "rate_limit_error",
  ResourceGone: "resource_gone",
  ResourceNotFound: "resource_not_found",
  Unauthorized: "unauthorized",
  ValidationError: "validation_error"
}, an = {
  Included: "INCLUDED",
  NotIncluded: "NOT_INCLUDED",
  Optional: "OPTIONAL"
}, sn = {
  BestMatch: "BEST_MATCH",
  Cheapest: "CHEAPEST",
  MatchingRoomCount: "MATCHING_ROOM_COUNT",
  Regular: "REGULAR"
}, un = {
  HotelRoom: "HOTEL_ROOM",
  Package: "PACKAGE"
}, cn = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
}, ln = {
  CreditNote: "credit_note",
  Invoice: "invoice"
}, fn = {
  CreditCard: "CREDIT_CARD"
}, dn = {
  Coupon: "COUPON"
}, hn = {
  DepositAccount: "DEPOSIT_ACCOUNT"
}, pn = {
  Coupon: "COUPON",
  CreditCard: "CREDIT_CARD",
  DepositAccount: "DEPOSIT_ACCOUNT"
}, mn = {
  Complete: "COMPLETE",
  InProgress: "IN_PROGRESS"
}, yn = {
  Ad: "AD",
  Ae: "AE",
  Af: "AF",
  Ag: "AG",
  Ai: "AI",
  Al: "AL",
  Am: "AM",
  Ao: "AO",
  Ar: "AR",
  As: "AS",
  At: "AT",
  Au: "AU",
  Aw: "AW",
  Ax: "AX",
  Az: "AZ",
  Ba: "BA",
  Bb: "BB",
  Bd: "BD",
  Be: "BE",
  Bf: "BF",
  Bg: "BG",
  Bh: "BH",
  Bi: "BI",
  Bj: "BJ",
  Bl: "BL",
  Bm: "BM",
  Bn: "BN",
  Bo: "BO",
  Bq: "BQ",
  Br: "BR",
  Bs: "BS",
  Bt: "BT",
  Bw: "BW",
  By: "BY",
  Bz: "BZ",
  Ca: "CA",
  Cc: "CC",
  Cd: "CD",
  Cf: "CF",
  Cg: "CG",
  Ch: "CH",
  Ci: "CI",
  Ck: "CK",
  Cl: "CL",
  Cm: "CM",
  Cn: "CN",
  Co: "CO",
  Cr: "CR",
  Cu: "CU",
  Cv: "CV",
  Cw: "CW",
  Cx: "CX",
  Cy: "CY",
  Cz: "CZ",
  De: "DE",
  Dj: "DJ",
  Dk: "DK",
  Dm: "DM",
  Do: "DO",
  Dz: "DZ",
  Ec: "EC",
  Ee: "EE",
  Eg: "EG",
  Eh: "EH",
  Er: "ER",
  Es: "ES",
  Et: "ET",
  Fi: "FI",
  Fj: "FJ",
  Fk: "FK",
  Fm: "FM",
  Fo: "FO",
  Fr: "FR",
  Ga: "GA",
  Gb: "GB",
  Gd: "GD",
  Ge: "GE",
  Gf: "GF",
  Gg: "GG",
  Gh: "GH",
  Gi: "GI",
  Gl: "GL",
  Gm: "GM",
  Gn: "GN",
  Gp: "GP",
  Gq: "GQ",
  Gr: "GR",
  Gt: "GT",
  Gu: "GU",
  Gw: "GW",
  Gy: "GY",
  Hk: "HK",
  Hn: "HN",
  Hr: "HR",
  Ht: "HT",
  Hu: "HU",
  Id: "ID",
  Ie: "IE",
  Il: "IL",
  Im: "IM",
  In: "IN",
  Io: "IO",
  Iq: "IQ",
  Ir: "IR",
  Is: "IS",
  It: "IT",
  Je: "JE",
  Jm: "JM",
  Jo: "JO",
  Jp: "JP",
  Ke: "KE",
  Kg: "KG",
  Kh: "KH",
  Ki: "KI",
  Km: "KM",
  Kn: "KN",
  Kp: "KP",
  Kr: "KR",
  Kw: "KW",
  Ky: "KY",
  Kz: "KZ",
  La: "LA",
  Lb: "LB",
  Lc: "LC",
  Li: "LI",
  Lk: "LK",
  Lr: "LR",
  Ls: "LS",
  Lt: "LT",
  Lu: "LU",
  Lv: "LV",
  Ly: "LY",
  Ma: "MA",
  Mc: "MC",
  Md: "MD",
  Me: "ME",
  Mf: "MF",
  Mg: "MG",
  Mh: "MH",
  Mk: "MK",
  Ml: "ML",
  Mm: "MM",
  Mn: "MN",
  Mo: "MO",
  Mp: "MP",
  Mq: "MQ",
  Mr: "MR",
  Ms: "MS",
  Mt: "MT",
  Mu: "MU",
  Mv: "MV",
  Mw: "MW",
  Mx: "MX",
  My: "MY",
  Mz: "MZ",
  Na: "NA",
  Nc: "NC",
  Ne: "NE",
  Nf: "NF",
  Ng: "NG",
  Ni: "NI",
  Nl: "NL",
  No: "NO",
  Np: "NP",
  Nr: "NR",
  Nu: "NU",
  Nz: "NZ",
  Om: "OM",
  Pa: "PA",
  Pe: "PE",
  Pf: "PF",
  Pg: "PG",
  Ph: "PH",
  Pk: "PK",
  Pl: "PL",
  Pm: "PM",
  Pr: "PR",
  Ps: "PS",
  Pt: "PT",
  Pw: "PW",
  Py: "PY",
  Qa: "QA",
  Re: "RE",
  Ro: "RO",
  Rs: "RS",
  Ru: "RU",
  Rw: "RW",
  Sa: "SA",
  Sb: "SB",
  Sc: "SC",
  Sd: "SD",
  Se: "SE",
  Sg: "SG",
  Sh: "SH",
  Si: "SI",
  Sj: "SJ",
  Sk: "SK",
  Sl: "SL",
  Sm: "SM",
  Sn: "SN",
  So: "SO",
  Sr: "SR",
  Ss: "SS",
  St: "ST",
  Sv: "SV",
  Sx: "SX",
  Sy: "SY",
  Sz: "SZ",
  Tc: "TC",
  Td: "TD",
  Tg: "TG",
  Th: "TH",
  Tj: "TJ",
  Tk: "TK",
  Tl: "TL",
  Tm: "TM",
  Tn: "TN",
  To: "TO",
  Tr: "TR",
  Tt: "TT",
  Tv: "TV",
  Tw: "TW",
  Tz: "TZ",
  Ua: "UA",
  Ug: "UG",
  Us: "US",
  Uy: "UY",
  Uz: "UZ",
  Va: "VA",
  Vc: "VC",
  Ve: "VE",
  Vg: "VG",
  Vi: "VI",
  Vn: "VN",
  Vu: "VU",
  Wf: "WF",
  Ws: "WS",
  Xk: "XK",
  Ye: "YE",
  Yt: "YT",
  Za: "ZA",
  Zm: "ZM",
  Zw: "ZW"
}, gn = {
  Night: "PER_NIGHT",
  Stay: "PER_STAY"
}, wn = {
  Adult: "PER_ADULT",
  Booking: "PER_BOOKING"
};
class kr extends W {
  /**
   * In order to be able to create and confirm a booking against a specific **Hotel Room Offer** package, you need to make a booking policy call.  Retrieving a booking policy returns additional information about the booking being made and includes details like cancellation policies.  This API call is equivalent to an availability check and it is important not to let long periods between retrieval of this policy and the booking confirmation call itself as this will often reduce the likelihood of the **Hotel Room Offer** being successfully booked.  The **booking_policy_id** returned is meant to be used to carry out a pre-book call via **[Pre Book endpoint](/v1/documentation#operation/postV1Bookings)** on the next **Booking Flow** step.  ⚠️ This call may take from 1 second up to 15 seconds to return as we may request various suppliers to fulfill this request.
   * Create Booking Policies
   */
  async createRaw(e, r) {
    const t = {}, n = {};
    n["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/booking_policies",
      method: "POST",
      headers: n,
      query: w(t, S.Snake),
      body: w(e.bookingPoliciesCreateApi, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * In order to be able to create and confirm a booking against a specific **Hotel Room Offer** package, you need to make a booking policy call.  Retrieving a booking policy returns additional information about the booking being made and includes details like cancellation policies.  This API call is equivalent to an availability check and it is important not to let long periods between retrieval of this policy and the booking confirmation call itself as this will often reduce the likelihood of the **Hotel Room Offer** being successfully booked.  The **booking_policy_id** returned is meant to be used to carry out a pre-book call via **[Pre Book endpoint](/v1/documentation#operation/postV1Bookings)** on the next **Booking Flow** step.  ⚠️ This call may take from 1 second up to 15 seconds to return as we may request various suppliers to fulfill this request.
   * Create Booking Policies
   */
  async create(e = {}, r) {
    return this.createRaw(e, r);
  }
}
class _r extends W {
  /**
   * Cancel a confirmed Booking. A booking can only be cancelled if it\'s in one of the following status: **bkg-cf**, **bkg-pc**.
   * Cancel a Booking
   */
  async deleteRaw(e, r) {
    if (e.token === null || e.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling deleteV1BookingsToken.");
    const t = {}, n = {}, s = await this.request({
      path: "/v1/bookings/{token}".replace("{token}", encodeURIComponent(String(e.token))),
      method: "DELETE",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Cancel a confirmed Booking. A booking can only be cancelled if it\'s in one of the following status: **bkg-cf**, **bkg-pc**.
   * Cancel a Booking
   */
  async delete(e, r) {
    return this.deleteRaw(e, r);
  }
  /**
   * Returns a list of detailed bookings made on behalf of a specific API Key credential.
   * List Bookings
   */
  async listRaw(e, r) {
    const t = {};
    e.endingBefore !== void 0 && (t.ending_before = e.endingBefore), e.filterByCheckInDate !== void 0 && (t.filter_by_check_in_date = e.filterByCheckInDate), e.filterByLastStatusUpdatedAt !== void 0 && (t.filter_by_last_status_updated_at = e.filterByLastStatusUpdatedAt), e.filterByStatus !== void 0 && (t.filter_by_status = e.filterByStatus), e.limit !== void 0 && (t.limit = e.limit), e.sortBy !== void 0 && (t.sort_by = e.sortBy), e.sortByOrder !== void 0 && (t.sort_by_order = e.sortByOrder), e.startingAfter !== void 0 && (t.starting_after = e.startingAfter);
    const n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/bookings",
      method: "GET",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Returns a list of detailed bookings made on behalf of a specific API Key credential.
   * List Bookings
   */
  async list(e = {}, r) {
    return this.listRaw(e, r);
  }
  /**
   * Retrieve the status and information of a booking.
   * Retrieve a Booking
   */
  async retrieveRaw(e, r) {
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling getV1BookingsId.");
    const t = {}, n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/bookings/{id}".replace("{id}", encodeURIComponent(String(e.id))),
      method: "GET",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Retrieve the status and information of a booking.
   * Retrieve a Booking
   */
  async retrieve(e, r) {
    return this.retrieveRaw(e, r);
  }
  /**
   * Retrieve the status and information of a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Retrieve a Booking (PUBLIC)
   */
  async retrievePublicRaw(e, r) {
    if (e.token === null || e.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling getV1BookingsTokenPublic.");
    const t = {}, n = {}, s = await this.request({
      path: "/v1/bookings/{token}/public".replace("{token}", encodeURIComponent(String(e.token))),
      method: "GET",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Retrieve the status and information of a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Retrieve a Booking (PUBLIC)
   */
  async retrievePublic(e, r) {
    return this.retrievePublicRaw(e, r);
  }
  /**
   * Creates an unconfirmed booking
   * Create an unconfirmed Booking
   */
  async createRaw(e, r) {
    const t = {}, n = {};
    n["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/bookings",
      method: "POST",
      headers: n,
      query: w(t, S.Snake),
      body: w(e.bookingCreateApi, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Creates an unconfirmed booking
   * Create an unconfirmed Booking
   */
  async create(e = {}, r) {
    return this.createRaw(e, r);
  }
  /**
   * Confirm booking from Coupon payment method
   * Confirm booking from Coupon payment method
   */
  async couponChargeRaw(e, r) {
    if (e.couponId === null || e.couponId === void 0)
      throw new U("couponId", "Required parameter requestParameters.couponId was null or undefined when calling postV1BookingsIdCouponsCouponIdCharge.");
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling postV1BookingsIdCouponsCouponIdCharge.");
    const t = {}, n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/bookings/{id}/coupons/{coupon_id}/charge".replace("{coupon_id}", encodeURIComponent(String(e.couponId))).replace("{id}", encodeURIComponent(String(e.id))),
      method: "POST",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Confirm booking from Coupon payment method
   * Confirm booking from Coupon payment method
   */
  async couponCharge(e, r) {
    return this.couponChargeRaw(e, r);
  }
  /**
   * Pay later and retrieve the status and information of a booking.
   * Pay later a Booking
   */
  async paylaterRaw(e, r) {
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling postV1BookingsIdPayLater.");
    const t = {}, n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/bookings/{id}/pay-later".replace("{id}", encodeURIComponent(String(e.id))),
      method: "POST",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Pay later and retrieve the status and information of a booking.
   * Pay later a Booking
   */
  async paylater(e, r) {
    return this.paylaterRaw(e, r);
  }
  /**
   * Confirm later paid and retrieve the status and information of a booking.
   * Confirm a later paid Booking
   */
  async confirmpaylaterRaw(e, r) {
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling postV1BookingsIdPayLaterConfirm.");
    const t = {}, n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/bookings/{id}/pay-later/confirm".replace("{id}", encodeURIComponent(String(e.id))),
      method: "POST",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Confirm later paid and retrieve the status and information of a booking.
   * Confirm a later paid Booking
   */
  async confirmpaylater(e, r) {
    return this.confirmpaylaterRaw(e, r);
  }
  /**
   * Trigger the actual booking confirmation process.  💡 This endpoint is only available for Bookings in the **bkg-created** status.  ⚠️ The booking confirmation is an asynchronous process. The booking won\'t transition immediatly to **bkg-cf** status. Rather, the endpoint will return a booking in **bkg-ip** and you\'ll be required to check booking status calling **[Get Booking endpoint](/v1/documentation#operation/getV1BookingsId)**, ideally with a polling mechanism, and perform further action(s), whether you need to let your customer know about their booking or you just need to update some data on your system, when booking status transitions to **bkg-cf** (confirmed) or  **bkg-af** (fail).  ⚠️ Once you have called this endpoint, we immediatly send your confirmation request to our supplier(s) and they may confirm it immediatly, so you\'ll be liable for up to the total booking tax included price amount if you need to cancel it at a later time (refer to the booking\'s cancellation policies to get the actual current penalty percentage applied in case of cancellation).
   * Confirm an ongoing Booking
   */
  async confirmRaw(e, r) {
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling postV1BookingsIdconfirm.");
    const t = {}, n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/bookings/{id}/confirm".replace("{id}", encodeURIComponent(String(e.id))),
      method: "POST",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Trigger the actual booking confirmation process.  💡 This endpoint is only available for Bookings in the **bkg-created** status.  ⚠️ The booking confirmation is an asynchronous process. The booking won\'t transition immediatly to **bkg-cf** status. Rather, the endpoint will return a booking in **bkg-ip** and you\'ll be required to check booking status calling **[Get Booking endpoint](/v1/documentation#operation/getV1BookingsId)**, ideally with a polling mechanism, and perform further action(s), whether you need to let your customer know about their booking or you just need to update some data on your system, when booking status transitions to **bkg-cf** (confirmed) or  **bkg-af** (fail).  ⚠️ Once you have called this endpoint, we immediatly send your confirmation request to our supplier(s) and they may confirm it immediatly, so you\'ll be liable for up to the total booking tax included price amount if you need to cancel it at a later time (refer to the booking\'s cancellation policies to get the actual current penalty percentage applied in case of cancellation).
   * Confirm an ongoing Booking
   */
  async confirm(e, r) {
    return this.confirmRaw(e, r);
  }
  /**
   * Updates an ongoing Booking payment methods
   * Updates an ongoing Booking payment methods
   */
  async updatePaymentMethodsRaw(e, r) {
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling putV1BookingsIdPaymentMethods.");
    const t = {}, n = {};
    n["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/bookings/{id}/payment_methods".replace("{id}", encodeURIComponent(String(e.id))),
      method: "PUT",
      headers: n,
      query: w(t, S.Snake),
      body: w(e.paymentMethodUpdatePayloadApi, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Updates an ongoing Booking payment methods
   * Updates an ongoing Booking payment methods
   */
  async updatePaymentMethods(e, r) {
    return this.updatePaymentMethodsRaw(e, r);
  }
}
const vn = {
  CheckInDate: "check_in_date",
  CreatedAt: "created_at",
  LastStatusUpdatedAt: "last_status_updated_at"
}, Sn = {
  Asc: "asc",
  Desc: "desc"
};
class Dr extends W {
  /**
   * Returns a list of images for an Hotel Id with their content localize into the requested **lang**.
   * Retrieve Images of an Hotel
   */
  async retrieveRaw(e, r) {
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling getV1HotelsIdImages.");
    const t = {};
    e.lang !== void 0 && (t.lang = e.lang);
    const n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/hotels/{id}/images".replace("{id}", encodeURIComponent(String(e.id))),
      method: "GET",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Returns a list of images for an Hotel Id with their content localize into the requested **lang**.
   * Retrieve Images of an Hotel
   */
  async retrieve(e, r) {
    return this.retrieveRaw(e, r);
  }
}
const Rn = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
};
class br extends W {
  /**
   * Returns a single Hotel Offer Request by id
   * Retrieve a Single Hotel Offer Request
   */
  async retrieveRaw(e, r) {
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling getV1HotelOfferRequestsId.");
    const t = {}, n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/hotel_offer_requests/{id}".replace("{id}", encodeURIComponent(String(e.id))),
      method: "GET",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Returns a single Hotel Offer Request by id
   * Retrieve a Single Hotel Offer Request
   */
  async retrieve(e, r) {
    return this.retrieveRaw(e, r);
  }
  /**
   * Create an **Hotel Offer Request**. An **Hotel Offer Request** describes the guests (adult and child count), the ideal room count, when they want to check in and check out and obviously the location around which they need their accommodation to be (latitude/longitude pair).
   * Create an Hotel Offer Request
   */
  async createRaw(e, r) {
    const t = {}, n = {};
    n["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/hotel_offer_requests",
      method: "POST",
      headers: n,
      query: w(t, S.Snake),
      body: w(e.hotelOfferRequestCreateApi, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Create an **Hotel Offer Request**. An **Hotel Offer Request** describes the guests (adult and child count), the ideal room count, when they want to check in and check out and obviously the location around which they need their accommodation to be (latitude/longitude pair).
   * Create an Hotel Offer Request
   */
  async create(e = {}, r) {
    return this.createRaw(e, r);
  }
}
class Ir extends W {
  /**
   * You\'ll then make a call to the **Hotel Offers** endpoint to retrieve a list of **Hotel Offers** associated with your **Hotel Offer Request**. We\'ll send your search to a pool of hotels matching the search parameters you provided previously. The **Hotel Offers** endpoint will return hotels with available rates as **Hotel Room Offers** objects for each hotel in the list. For a detailed overview of the **Hotel Room Offer** object, see **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** endpoint.  ⚠️ **IMPORTANT**: The **Hotel Room Offers** included in each **Hotel Offer** returned by the **[Retrieve Hotel Offers](/v1/documentation#operation/getV1Hotel_offers)** endpoint might be **<span style=\"color:red\">cached data</span>**. In that case, the returned prices/availability may be slightly different from actual live inventory. In order to retrieve accurate and live **Hotel Room Offers** for a specific hotel you need to make a call to the **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** endpoint. We do not recommend to systematically call **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** for each hotel offer retrieved as it may trigger rate limiting on your API calls. Rather we recommend to do this as an explicit two-step process: first you check **Hotel Offers** around a location, then, once your customer shows interest in a specific **Hotel Offer**, you check **Hotel Room Offers** on that specific hotel.    This endpoint requires ⚛️ **[Polling](/v1/documentation#tag/Polling)**.
   * ⚛️ Retrieve Hotel Offers
   */
  async listRaw(e, r) {
    if (e.currency === null || e.currency === void 0)
      throw new U("currency", "Required parameter requestParameters.currency was null or undefined when calling getV1HotelOffers.");
    if (e.hotelOfferRequestId === null || e.hotelOfferRequestId === void 0)
      throw new U("hotelOfferRequestId", "Required parameter requestParameters.hotelOfferRequestId was null or undefined when calling getV1HotelOffers.");
    const t = {};
    e.currency !== void 0 && (t.currency = e.currency), e.endingBefore !== void 0 && (t.ending_before = e.endingBefore), e.filterByPrice !== void 0 && (t.filter_by_price = e.filterByPrice), e.filterByReviewRating !== void 0 && (t.filter_by_review_rating = e.filterByReviewRating), e.filterByStar !== void 0 && (t.filter_by_star = e.filterByStar), e.hotelOfferRequestId !== void 0 && (t.hotel_offer_request_id = e.hotelOfferRequestId), e.hotelRoomOffersLimit !== void 0 && (t.hotel_room_offers_limit = e.hotelRoomOffersLimit), e.includeHotelContentDetails !== void 0 && (t.include_hotel_content_details = e.includeHotelContentDetails), e.lang !== void 0 && (t.lang = e.lang), e.limit !== void 0 && (t.limit = e.limit), e.onlyRecommendedHotelOffers !== void 0 && (t.only_recommended_hotel_offers = e.onlyRecommendedHotelOffers), e.priceHistogramStepCount !== void 0 && (t.price_histogram_step_count = e.priceHistogramStepCount), e.sortBy !== void 0 && (t.sort_by = e.sortBy), e.sortByOrder !== void 0 && (t.sort_by_order = e.sortByOrder), e.startingAfter !== void 0 && (t.starting_after = e.startingAfter);
    const n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/hotel_offers",
      method: "GET",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * You\'ll then make a call to the **Hotel Offers** endpoint to retrieve a list of **Hotel Offers** associated with your **Hotel Offer Request**. We\'ll send your search to a pool of hotels matching the search parameters you provided previously. The **Hotel Offers** endpoint will return hotels with available rates as **Hotel Room Offers** objects for each hotel in the list. For a detailed overview of the **Hotel Room Offer** object, see **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** endpoint.  ⚠️ **IMPORTANT**: The **Hotel Room Offers** included in each **Hotel Offer** returned by the **[Retrieve Hotel Offers](/v1/documentation#operation/getV1Hotel_offers)** endpoint might be **<span style=\"color:red\">cached data</span>**. In that case, the returned prices/availability may be slightly different from actual live inventory. In order to retrieve accurate and live **Hotel Room Offers** for a specific hotel you need to make a call to the **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** endpoint. We do not recommend to systematically call **[Retrieve Hotel Room Offers](/v1/documentation#operation/getV1Hotel_room_offers)** for each hotel offer retrieved as it may trigger rate limiting on your API calls. Rather we recommend to do this as an explicit two-step process: first you check **Hotel Offers** around a location, then, once your customer shows interest in a specific **Hotel Offer**, you check **Hotel Room Offers** on that specific hotel.    This endpoint requires ⚛️ **[Polling](/v1/documentation#tag/Polling)**.
   * ⚛️ Retrieve Hotel Offers
   */
  async list(e, r, t) {
    return await nt(
      () => this.listRaw(e, t),
      { type: De.HOTEL_SEARCH_POLLING, minCallCount: t?.minCallCount, maxCallCount: t?.maxCallCount },
      r
    );
  }
}
const Cn = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
}, An = {
  Distance: "distance",
  Price: "price",
  Rating: "rating",
  ReviewRating: "review_rating",
  TopPicks: "top_picks"
}, Tn = {
  Asc: "asc",
  Desc: "desc"
};
class Br extends W {
  /**
   * Returns a single Hotel Room Offer Request by id
   * Retrieve a Single Hotel Room Offer Request
   */
  async retrieveRaw(e, r) {
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling getV1HotelRoomOfferRequestsId.");
    const t = {}, n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/hotel_room_offer_requests/{id}".replace("{id}", encodeURIComponent(String(e.id))),
      method: "GET",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Returns a single Hotel Room Offer Request by id
   * Retrieve a Single Hotel Room Offer Request
   */
  async retrieve(e, r) {
    return this.retrieveRaw(e, r);
  }
  /**
   * To check available rates, or **Hotel Room Offers**, at a specific hotel, you first need to create an **Hotel Room Offer Request**. An **Hotel Room Offer Request** describes the guests (adult and child count), the ideal room count, when they want to check in and check out and the id of the hotel you want to check available rates at.
   * Create an Hotel Room Offer Request
   */
  async createRaw(e, r) {
    const t = {}, n = {};
    n["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/hotel_room_offer_requests",
      method: "POST",
      headers: n,
      query: w(t, S.Snake),
      body: w(e.hotelRoomOfferRequestCreateApi, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * To check available rates, or **Hotel Room Offers**, at a specific hotel, you first need to create an **Hotel Room Offer Request**. An **Hotel Room Offer Request** describes the guests (adult and child count), the ideal room count, when they want to check in and check out and the id of the hotel you want to check available rates at.
   * Create an Hotel Room Offer Request
   */
  async create(e = {}, r) {
    return this.createRaw(e, r);
  }
}
class xr extends W {
  /**
   * You\'ll make a call to the **Hotel Room Offers** endpoint in order to get a list of **Hotel Room Offers** resulting from your **Hotel Room Offer Request** parameters. We\'ll send your rate check request to the specific hotel matching the hotel ID you provided previously and the **Hotel Room Offers** endpoint will return the available rates at this specific hotel. An **Hotel Room Offer** describes hotel rooms: prices, remaining count available (when applicable), details about the room itself (e.g., beds, etc) and other information you\'ll find below.   ⚠️ **Cancellation Policies** attached to each **Hotel Room Offer** returned by this endpoint will most likely be **<span style=\"color:red\">cached data</span>** and should not be considered as accurate, although in most case they will reflect the actual/live ones.  In order to retrieve accurate and live **Cancellation Policies** for a specific **Hotel Room Offer** you need to make a call to the **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)**. However, we do not recommend to systematically call **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** for each **Hotel Room Offer** retrieved as it will most likely trigger rate limiting on your API calls. Rather we recommend to do this as an explicit two-step process: first you check **Hotel Room Offers**, then, once your customer shows interest in a specific **Hotel Room Offer**, you make the call to the **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** on behalf of your customer.    This endpoint requires ⚛️ **[Polling](/v1/documentation#tag/Polling)**.
   * ⚛️ Retrieve Hotel Room Offers
   */
  async listRaw(e, r) {
    if (e.currency === null || e.currency === void 0)
      throw new U("currency", "Required parameter requestParameters.currency was null or undefined when calling getV1HotelRoomOffers.");
    if (e.hotelRoomOfferRequestId === null || e.hotelRoomOfferRequestId === void 0)
      throw new U("hotelRoomOfferRequestId", "Required parameter requestParameters.hotelRoomOfferRequestId was null or undefined when calling getV1HotelRoomOffers.");
    const t = {};
    e.currency !== void 0 && (t.currency = e.currency), e.hotelRoomOfferRequestId !== void 0 && (t.hotel_room_offer_request_id = e.hotelRoomOfferRequestId), e.lang !== void 0 && (t.lang = e.lang), e.limit !== void 0 && (t.limit = e.limit);
    const n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/hotel_room_offers",
      method: "GET",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * You\'ll make a call to the **Hotel Room Offers** endpoint in order to get a list of **Hotel Room Offers** resulting from your **Hotel Room Offer Request** parameters. We\'ll send your rate check request to the specific hotel matching the hotel ID you provided previously and the **Hotel Room Offers** endpoint will return the available rates at this specific hotel. An **Hotel Room Offer** describes hotel rooms: prices, remaining count available (when applicable), details about the room itself (e.g., beds, etc) and other information you\'ll find below.   ⚠️ **Cancellation Policies** attached to each **Hotel Room Offer** returned by this endpoint will most likely be **<span style=\"color:red\">cached data</span>** and should not be considered as accurate, although in most case they will reflect the actual/live ones.  In order to retrieve accurate and live **Cancellation Policies** for a specific **Hotel Room Offer** you need to make a call to the **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)**. However, we do not recommend to systematically call **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** for each **Hotel Room Offer** retrieved as it will most likely trigger rate limiting on your API calls. Rather we recommend to do this as an explicit two-step process: first you check **Hotel Room Offers**, then, once your customer shows interest in a specific **Hotel Room Offer**, you make the call to the **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** on behalf of your customer.    This endpoint requires ⚛️ **[Polling](/v1/documentation#tag/Polling)**.
   * ⚛️ Retrieve Hotel Room Offers
   */
  async list(e, r, t) {
    return await nt(
      () => this.listRaw(e, t),
      { type: De.HOTEL_ROOM_OFFERS, minCallCount: t?.minCallCount, maxCallCount: t?.maxCallCount },
      r
    );
  }
  /**
   * This enpoint creates a new **Hotel Room Offer** based on previously fetched **Hotel Room Offer(s)** and may be used for the following purposes:  - Check a specific **Hotel Room Offer** live availability  - Create a new **Hotel Room Offer** with **type = \"PACKAGE\"** based on multiple **Hotel Room Offers** where **type = \"HOTEL_ROOM\"** and be able to call **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** with it  - Update an existing **Hotel Room Offer** with **type = \"PACKAGE\"** in order to include extra option(s) like breakfast in the returned price.   We strongly recommend to make use of this endpoint if you want to offer some kind of Shopping Cart experience to your customer when **[Retrieve HotelRoom Offers endpoint](/v1/documentation#operation/getV1Hotel_room_offers)** returns multiple **Hotel Room Offers** with **type = \"HOTEL_ROOM\"**.
   * Create Hotel Room Offer
   */
  async createRaw(e, r) {
    const t = {}, n = {};
    n["Content-Type"] = "application/json", this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/hotel_room_offers",
      method: "POST",
      headers: n,
      query: w(t, S.Snake),
      body: w(e.hotelRoomOffersCreateApi, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * This enpoint creates a new **Hotel Room Offer** based on previously fetched **Hotel Room Offer(s)** and may be used for the following purposes:  - Check a specific **Hotel Room Offer** live availability  - Create a new **Hotel Room Offer** with **type = \"PACKAGE\"** based on multiple **Hotel Room Offers** where **type = \"HOTEL_ROOM\"** and be able to call **[Create Booking Policies endpoint](/v1/documentation#operation/postV1Booking_policies)** with it  - Update an existing **Hotel Room Offer** with **type = \"PACKAGE\"** in order to include extra option(s) like breakfast in the returned price.   We strongly recommend to make use of this endpoint if you want to offer some kind of Shopping Cart experience to your customer when **[Retrieve HotelRoom Offers endpoint](/v1/documentation#operation/getV1Hotel_room_offers)** returns multiple **Hotel Room Offers** with **type = \"HOTEL_ROOM\"**.
   * Create Hotel Room Offer
   */
  async create(e = {}, r) {
    return this.createRaw(e, r);
  }
}
const Mn = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
};
class Lr extends W {
  /**
   * Delete a hotel rooming list guest from a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Delete Hotel Room List Guest
   */
  async deleteRaw(e, r) {
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling deleteV1HotelRoomingListGuestsTokenId.");
    if (e.token === null || e.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling deleteV1HotelRoomingListGuestsTokenId.");
    const t = {}, n = {}, s = await this.request({
      path: "/v1/hotel_rooming_list_guests/{token}/{id}".replace("{id}", encodeURIComponent(String(e.id))).replace("{token}", encodeURIComponent(String(e.token))),
      method: "DELETE",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return new Or(s);
  }
  /**
   * Delete a hotel rooming list guest from a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Delete Hotel Room List Guest
   */
  async delete(e, r) {
    return this.deleteRaw(e, r);
  }
  /**
   * Update a hotel rooming list guest from a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Update Hotel Room List Guest
   */
  async updateRaw(e, r) {
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling patchV1HotelRoomingListGuestsTokenId.");
    if (e.token === null || e.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling patchV1HotelRoomingListGuestsTokenId.");
    const t = {}, n = {};
    n["Content-Type"] = "application/json";
    const s = await this.request({
      path: "/v1/hotel_rooming_list_guests/{token}/{id}".replace("{id}", encodeURIComponent(String(e.id))).replace("{token}", encodeURIComponent(String(e.token))),
      method: "PATCH",
      headers: n,
      query: w(t, S.Snake),
      body: w(e.hotelRoomingListGuestsUpdateApi, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Update a hotel rooming list guest from a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Update Hotel Room List Guest
   */
  async update(e, r) {
    return this.updateRaw(e, r);
  }
  /**
   * Create a new hotel rooming list guest to a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Create Hotel Rooming List Guest
   */
  async createRaw(e, r) {
    if (e.token === null || e.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling postV1HotelRoomingListGuestsToken.");
    const t = {}, n = {};
    n["Content-Type"] = "application/json";
    const s = await this.request({
      path: "/v1/hotel_rooming_list_guests/{token}".replace("{token}", encodeURIComponent(String(e.token))),
      method: "POST",
      headers: n,
      query: w(t, S.Snake),
      body: w(e.hotelRoomingListGuestsCreateApi, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Create a new hotel rooming list guest to a booking based on a valid token. This endpoint is public and does not require a secret API key.
   * Create Hotel Rooming List Guest
   */
  async create(e, r) {
    return this.createRaw(e, r);
  }
}
class Pr extends W {
  /**
   * Get Hotel Rooming Lists of a booking. This endpoint is public and does not require a secret API key.
   * Get Hotel Rooming Lists for a booking
   */
  async listRaw(e, r) {
    if (e.token === null || e.token === void 0)
      throw new U("token", "Required parameter requestParameters.token was null or undefined when calling getV1HotelRoomingListsToken.");
    const t = {};
    e.lang !== void 0 && (t.lang = e.lang);
    const n = {}, s = await this.request({
      path: "/v1/hotel_rooming_lists/{token}".replace("{token}", encodeURIComponent(String(e.token))),
      method: "GET",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Get Hotel Rooming Lists of a booking. This endpoint is public and does not require a secret API key.
   * Get Hotel Rooming Lists for a booking
   */
  async list(e, r) {
    return this.listRaw(e, r);
  }
}
const En = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
};
class $r extends W {
  /**
   * Returns a single Hotel by id with their content localize into the requested **lang**.
   * Retrieve a Hotel
   */
  async retrieveRaw(e, r) {
    if (e.id === null || e.id === void 0)
      throw new U("id", "Required parameter requestParameters.id was null or undefined when calling getV1HotelsId.");
    const t = {};
    e.event !== void 0 && (t.event = e.event), e.lang !== void 0 && (t.lang = e.lang);
    const n = {};
    this.configuration && this.configuration.apiKey && (n["x-api-key"] = this.configuration.apiKey("x-api-key"));
    const s = await this.request({
      path: "/v1/hotels/{id}".replace("{id}", encodeURIComponent(String(e.id))),
      method: "GET",
      headers: n,
      query: w(t, S.Snake)
    }, r);
    return await new $(s, (u) => w(u, S.Camel)).value();
  }
  /**
   * Returns a single Hotel by id with their content localize into the requested **lang**.
   * Retrieve a Hotel
   */
  async retrieve(e, r) {
    return this.retrieveRaw(e, r);
  }
}
const On = {
  DeDe: "de-DE",
  EnUs: "en-US",
  EsEs: "es-ES",
  FrFr: "fr-FR",
  ItIt: "it-IT",
  NlNl: "nl-NL",
  PtPt: "pt-PT"
};
var ue = { exports: {} }, Ze;
function Ur() {
  return Ze || (Ze = 1, (function(i, e) {
    var r = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof se < "u" && se, t = (function() {
      function s() {
        this.fetch = !1, this.DOMException = r.DOMException;
      }
      return s.prototype = r, new s();
    })();
    (function(s) {
      (function(u) {
        var c = typeof s < "u" && s || typeof self < "u" && self || // eslint-disable-next-line no-undef
        typeof se < "u" && se || {}, h = {
          searchParams: "URLSearchParams" in c,
          iterable: "Symbol" in c && "iterator" in Symbol,
          blob: "FileReader" in c && "Blob" in c && (function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          })(),
          formData: "FormData" in c,
          arrayBuffer: "ArrayBuffer" in c
        };
        function v(o) {
          return o && DataView.prototype.isPrototypeOf(o);
        }
        if (h.arrayBuffer)
          var C = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], y = ArrayBuffer.isView || function(o) {
            return o && C.indexOf(Object.prototype.toString.call(o)) > -1;
          };
        function m(o) {
          if (typeof o != "string" && (o = String(o)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(o) || o === "")
            throw new TypeError('Invalid character in header field name: "' + o + '"');
          return o.toLowerCase();
        }
        function A(o) {
          return typeof o != "string" && (o = String(o)), o;
        }
        function T(o) {
          var a = {
            next: function() {
              var f = o.shift();
              return { done: f === void 0, value: f };
            }
          };
          return h.iterable && (a[Symbol.iterator] = function() {
            return a;
          }), a;
        }
        function d(o) {
          this.map = {}, o instanceof d ? o.forEach(function(a, f) {
            this.append(f, a);
          }, this) : Array.isArray(o) ? o.forEach(function(a) {
            if (a.length != 2)
              throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + a.length);
            this.append(a[0], a[1]);
          }, this) : o && Object.getOwnPropertyNames(o).forEach(function(a) {
            this.append(a, o[a]);
          }, this);
        }
        d.prototype.append = function(o, a) {
          o = m(o), a = A(a);
          var f = this.map[o];
          this.map[o] = f ? f + ", " + a : a;
        }, d.prototype.delete = function(o) {
          delete this.map[m(o)];
        }, d.prototype.get = function(o) {
          return o = m(o), this.has(o) ? this.map[o] : null;
        }, d.prototype.has = function(o) {
          return this.map.hasOwnProperty(m(o));
        }, d.prototype.set = function(o, a) {
          this.map[m(o)] = A(a);
        }, d.prototype.forEach = function(o, a) {
          for (var f in this.map)
            this.map.hasOwnProperty(f) && o.call(a, this.map[f], f, this);
        }, d.prototype.keys = function() {
          var o = [];
          return this.forEach(function(a, f) {
            o.push(f);
          }), T(o);
        }, d.prototype.values = function() {
          var o = [];
          return this.forEach(function(a) {
            o.push(a);
          }), T(o);
        }, d.prototype.entries = function() {
          var o = [];
          return this.forEach(function(a, f) {
            o.push([f, a]);
          }), T(o);
        }, h.iterable && (d.prototype[Symbol.iterator] = d.prototype.entries);
        function M(o) {
          if (!o._noBody) {
            if (o.bodyUsed)
              return Promise.reject(new TypeError("Already read"));
            o.bodyUsed = !0;
          }
        }
        function I(o) {
          return new Promise(function(a, f) {
            o.onload = function() {
              a(o.result);
            }, o.onerror = function() {
              f(o.error);
            };
          });
        }
        function b(o) {
          var a = new FileReader(), f = I(a);
          return a.readAsArrayBuffer(o), f;
        }
        function _(o) {
          var a = new FileReader(), f = I(a), l = /charset=([A-Za-z0-9_-]+)/.exec(o.type), g = l ? l[1] : "utf-8";
          return a.readAsText(o, g), f;
        }
        function P(o) {
          for (var a = new Uint8Array(o), f = new Array(a.length), l = 0; l < a.length; l++)
            f[l] = String.fromCharCode(a[l]);
          return f.join("");
        }
        function E(o) {
          if (o.slice)
            return o.slice(0);
          var a = new Uint8Array(o.byteLength);
          return a.set(new Uint8Array(o)), a.buffer;
        }
        function B() {
          return this.bodyUsed = !1, this._initBody = function(o) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = o, o ? typeof o == "string" ? this._bodyText = o : h.blob && Blob.prototype.isPrototypeOf(o) ? this._bodyBlob = o : h.formData && FormData.prototype.isPrototypeOf(o) ? this._bodyFormData = o : h.searchParams && URLSearchParams.prototype.isPrototypeOf(o) ? this._bodyText = o.toString() : h.arrayBuffer && h.blob && v(o) ? (this._bodyArrayBuffer = E(o.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : h.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(o) || y(o)) ? this._bodyArrayBuffer = E(o) : this._bodyText = o = Object.prototype.toString.call(o) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof o == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : h.searchParams && URLSearchParams.prototype.isPrototypeOf(o) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, h.blob && (this.blob = function() {
            var o = M(this);
            if (o)
              return o;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }), this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var o = M(this);
              return o || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else {
              if (h.blob)
                return this.blob().then(b);
              throw new Error("could not read as ArrayBuffer");
            }
          }, this.text = function() {
            var o = M(this);
            if (o)
              return o;
            if (this._bodyBlob)
              return _(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(P(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, h.formData && (this.formData = function() {
            return this.text().then(x);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var F = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
        function K(o) {
          var a = o.toUpperCase();
          return F.indexOf(a) > -1 ? a : o;
        }
        function N(o, a) {
          if (!(this instanceof N))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          a = a || {};
          var f = a.body;
          if (o instanceof N) {
            if (o.bodyUsed)
              throw new TypeError("Already read");
            this.url = o.url, this.credentials = o.credentials, a.headers || (this.headers = new d(o.headers)), this.method = o.method, this.mode = o.mode, this.signal = o.signal, !f && o._bodyInit != null && (f = o._bodyInit, o.bodyUsed = !0);
          } else
            this.url = String(o);
          if (this.credentials = a.credentials || this.credentials || "same-origin", (a.headers || !this.headers) && (this.headers = new d(a.headers)), this.method = K(a.method || this.method || "GET"), this.mode = a.mode || this.mode || null, this.signal = a.signal || this.signal || (function() {
            if ("AbortController" in c) {
              var p = new AbortController();
              return p.signal;
            }
          })(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && f)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(f), (this.method === "GET" || this.method === "HEAD") && (a.cache === "no-store" || a.cache === "no-cache")) {
            var l = /([?&])_=[^&]*/;
            if (l.test(this.url))
              this.url = this.url.replace(l, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var g = /\?/;
              this.url += (g.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        N.prototype.clone = function() {
          return new N(this, { body: this._bodyInit });
        };
        function x(o) {
          var a = new FormData();
          return o.trim().split("&").forEach(function(f) {
            if (f) {
              var l = f.split("="), g = l.shift().replace(/\+/g, " "), p = l.join("=").replace(/\+/g, " ");
              a.append(decodeURIComponent(g), decodeURIComponent(p));
            }
          }), a;
        }
        function O(o) {
          var a = new d(), f = o.replace(/\r?\n[\t ]+/g, " ");
          return f.split("\r").map(function(l) {
            return l.indexOf(`
`) === 0 ? l.substr(1, l.length) : l;
          }).forEach(function(l) {
            var g = l.split(":"), p = g.shift().trim();
            if (p) {
              var D = g.join(":").trim();
              try {
                a.append(p, D);
              } catch (L) {
                console.warn("Response " + L.message);
              }
            }
          }), a;
        }
        B.call(N.prototype);
        function V(o, a) {
          if (!(this instanceof V))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          if (a || (a = {}), this.type = "default", this.status = a.status === void 0 ? 200 : a.status, this.status < 200 || this.status > 599)
            throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
          this.ok = this.status >= 200 && this.status < 300, this.statusText = a.statusText === void 0 ? "" : "" + a.statusText, this.headers = new d(a.headers), this.url = a.url || "", this._initBody(o);
        }
        B.call(V.prototype), V.prototype.clone = function() {
          return new V(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new d(this.headers),
            url: this.url
          });
        }, V.error = function() {
          var o = new V(null, { status: 200, statusText: "" });
          return o.ok = !1, o.status = 0, o.type = "error", o;
        };
        var oe = [301, 302, 303, 307, 308];
        V.redirect = function(o, a) {
          if (oe.indexOf(a) === -1)
            throw new RangeError("Invalid status code");
          return new V(null, { status: a, headers: { location: o } });
        }, u.DOMException = c.DOMException;
        try {
          new u.DOMException();
        } catch {
          u.DOMException = function(a, f) {
            this.message = a, this.name = f;
            var l = Error(a);
            this.stack = l.stack;
          }, u.DOMException.prototype = Object.create(Error.prototype), u.DOMException.prototype.constructor = u.DOMException;
        }
        function R(o, a) {
          return new Promise(function(f, l) {
            var g = new N(o, a);
            if (g.signal && g.signal.aborted)
              return l(new u.DOMException("Aborted", "AbortError"));
            var p = new XMLHttpRequest();
            function D() {
              p.abort();
            }
            p.onload = function() {
              var k = {
                statusText: p.statusText,
                headers: O(p.getAllResponseHeaders() || "")
              };
              g.url.indexOf("file://") === 0 && (p.status < 200 || p.status > 599) ? k.status = 200 : k.status = p.status, k.url = "responseURL" in p ? p.responseURL : k.headers.get("X-Request-URL");
              var H = "response" in p ? p.response : p.responseText;
              setTimeout(function() {
                f(new V(H, k));
              }, 0);
            }, p.onerror = function() {
              setTimeout(function() {
                l(new TypeError("Network request failed"));
              }, 0);
            }, p.ontimeout = function() {
              setTimeout(function() {
                l(new TypeError("Network request timed out"));
              }, 0);
            }, p.onabort = function() {
              setTimeout(function() {
                l(new u.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function L(k) {
              try {
                return k === "" && c.location.href ? c.location.href : k;
              } catch {
                return k;
              }
            }
            if (p.open(g.method, L(g.url), !0), g.credentials === "include" ? p.withCredentials = !0 : g.credentials === "omit" && (p.withCredentials = !1), "responseType" in p && (h.blob ? p.responseType = "blob" : h.arrayBuffer && (p.responseType = "arraybuffer")), a && typeof a.headers == "object" && !(a.headers instanceof d || c.Headers && a.headers instanceof c.Headers)) {
              var G = [];
              Object.getOwnPropertyNames(a.headers).forEach(function(k) {
                G.push(m(k)), p.setRequestHeader(k, A(a.headers[k]));
              }), g.headers.forEach(function(k, H) {
                G.indexOf(H) === -1 && p.setRequestHeader(H, k);
              });
            } else
              g.headers.forEach(function(k, H) {
                p.setRequestHeader(H, k);
              });
            g.signal && (g.signal.addEventListener("abort", D), p.onreadystatechange = function() {
              p.readyState === 4 && g.signal.removeEventListener("abort", D);
            }), p.send(typeof g._bodyInit > "u" ? null : g._bodyInit);
          });
        }
        return R.polyfill = !0, c.fetch || (c.fetch = R, c.Headers = d, c.Request = N, c.Response = V), u.Headers = d, u.Request = N, u.Response = V, u.fetch = R, u;
      })({});
    })(t), t.fetch.ponyfill = !0, delete t.fetch.polyfill;
    var n = r.fetch ? r : t;
    e = n.fetch, e.default = n.fetch, e.fetch = n.fetch, e.Headers = n.Headers, e.Request = n.Request, e.Response = n.Response, i.exports = e;
  })(ue, ue.exports)), ue.exports;
}
var Nr = Ur();
const Gr = /* @__PURE__ */ j(Nr), Hr = (i) => ({
  bookingPolicies: new kr(i),
  bookings: new _r(i),
  hotelImages: new Dr(i),
  hotelOfferRequests: new br(i),
  hotelOffers: new Ir(i),
  hotelRoomOfferRequests: new Br(i),
  hotelRoomOffers: new xr(i),
  hotelRoomingListGuests: new Lr(i),
  hotelRoomingLists: new Pr(i),
  hotels: new $r(i)
});
function Fr(i) {
  switch (i) {
    case ee.Production:
      return "AUTH_TOKEN";
    case ee.Sandbox:
      return "AUTH_TOKEN_SANDBOX";
    case ee.Staging:
      return "AUTH_TOKEN_STAGING";
    case ee.CiCd:
      return "AUTH_TOKEN_CICD";
    case ee.Local:
      return "AUTH_TOKEN_LOCAL";
    case void 0:
    default:
      return "AUTH_TOKEN";
  }
}
function at(i) {
  return !!(typeof document < "u" && document?.cookie && document.cookie.split(";").find(
    (t) => t.includes(Fr(i))
  ));
}
class Kr {
  constructor(e) {
    this.config = e;
  }
  // eslint-disable-next-line @typescript-eslint/require-await
  async pre(e) {
    return e.init.mode = "cors", at(this.config.apiEnvironment) && (e.init.credentials = "include"), e;
  }
}
class Yr {
  constructor(e) {
    this.config = e;
  }
  // eslint-disable-next-line @typescript-eslint/require-await
  async pre(e) {
    return at(this.config.apiEnvironment) && (e.init.headers = {
      ...e.init.headers,
      "x-auth-type": "user"
    }), e;
  }
}
class kn {
  constructor(e) {
    if (this.config = e, !e.apiVersion || !Object.values(Oe).includes(e.apiVersion))
      throw new Error(
        `Invalid Revolugo Api Version. Possible versions are : ${JSON.stringify(
          Object.values(Oe)
        )}`
      );
    let r = {
      "x-api-key": this.config.apiKey
    };
    this.config.optionalHeaders && (r = {
      ...r,
      ...this.config.optionalHeaders
    });
    const t = this.config.apiEnvironment;
    let n = this.config.apiBaseUrl ?? Tt[t];
    t === ee.Local && process.env.BOOKING_API_BASE_URL && (n = process.env.BOOKING_API_BASE_URL);
    const s = new it({
      basePath: n,
      fetchApi: Gr,
      headers: r,
      middleware: [
        new Kr(this.config),
        new Yr(this.config)
      ]
    });
    this.apiVersionsToClient = {
      v1: Hr(s)
    };
  }
  apiVersionsToClient;
  get bookings() {
    return this.apiVersionsToClient[this.config.apiVersion].bookings;
  }
  get bookingPolicies() {
    return this.apiVersionsToClient[this.config.apiVersion].bookingPolicies;
  }
  get hotelOfferRequests() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelOfferRequests;
  }
  get hotelOffers() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelOffers;
  }
  get hotelRoomOfferRequests() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelRoomOfferRequests;
  }
  get hotelRoomOffers() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelRoomOffers;
  }
  get hotelRoomingListGuests() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelRoomingListGuests;
  }
  get hotelRoomingLists() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelRoomingLists;
  }
  get hotels() {
    return this.apiVersionsToClient[this.config.apiVersion].hotels;
  }
  get hotelImages() {
    return this.apiVersionsToClient[this.config.apiVersion].hotelImages;
  }
}
export {
  kn as ApiClient,
  Tr as BASE_PATH,
  W as BaseAPI,
  Zr as BlobApiResponse,
  Jr as BookingApiPayLaterEnum,
  Xr as BookingApiStatusEnum,
  kr as BookingPolicies,
  Qr as BookingPoliciesCreateApiLangEnum,
  _r as Bookings,
  vn as BookingsSortByEnum,
  Sn as BookingsSortByOrderEnum,
  Vr as COLLECTION_FORMATS,
  it as Configuration,
  en as ContactPersonApiLangEnum,
  tn as ContactPersonApiSalutationEnum,
  rn as CountryIso2Code,
  nn as CurrencyBookingApiClient,
  on as ErrorApiResponseTypeEnum,
  Dr as HotelImages,
  Rn as HotelImagesLangEnum,
  br as HotelOfferRequests,
  Ir as HotelOffers,
  Cn as HotelOffersLangEnum,
  An as HotelOffersSortByEnum,
  Tn as HotelOffersSortByOrderEnum,
  an as HotelRoomOfferApiBreakfastOptionEnum,
  sn as HotelRoomOfferApiPackageTypeEnum,
  un as HotelRoomOfferApiTypeEnum,
  Br as HotelRoomOfferRequests,
  xr as HotelRoomOffers,
  cn as HotelRoomOffersCreateApiLangEnum,
  Mn as HotelRoomOffersLangEnum,
  Lr as HotelRoomingListGuests,
  Pr as HotelRoomingLists,
  En as HotelRoomingListsLangEnum,
  $r as Hotels,
  On as HotelsLangEnum,
  ln as InvoiceApiTypeEnum,
  $ as JSONApiResponse,
  dn as PaymentMethodApiOneOf1NameEnum,
  hn as PaymentMethodApiOneOf2NameEnum,
  fn as PaymentMethodApiOneOfNameEnum,
  pn as PaymentMethodRequestApiNameEnum,
  mn as PollerStatus,
  U as RequiredError,
  Er as ResponseError,
  yn as SourceMarket,
  gn as TaxApiTaxFrequencyEnum,
  wn as TaxApiTaxModeEnum,
  Or as TextApiResponse,
  Wr as VoidApiResponse,
  zr as canConsumeForm,
  qr as exists,
  jr as mapValues,
  ot as querystring,
  Hr as v1ApiClient
};
